const content = {
	"activity": {
		"menu": "New Checklist",
		"title": "Checklist",
		"description": "A Checklist...",
		"properties": {
			"properties": {
				"title": {
					"name": "Title",
					"description": "The **Title** of the checklist."
				},
				"aiAssistantSummarize": {
					"name": "AI Assistant",
					"description": "The AI Assistant allows you to quickly summarize content in a variety of ways. The **Summarize Activity** extracts all content within the activity and then summarizes. The **Prompt for Description** is more generic and allows you to type any prompt or question in the above input (e.g. Label 1) and will generate a response that you can decide to paste into the appropriate input (e.g. Label 1)."
				},
				"hideTitleInAppBar": {
					"name": "Hide Title in App Bar",
					"description": "Hides the title in the main app bar. This is a great option when you want to add a Logo Image."
				},
				"suppressAudioTitle": {
					"name": "Don't Speak Title",
					"description": "Mira will not read the title."
				},
				"titleNarrationOverride": {
					"name": "Title Narration Override",
					"description": {
						"description": "Mira will read this content instead of the content in the **Title** property. Use **Paste Title** to paste the current title as a starting point.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Enhancing Pronunciation",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/tts-phonetics/index.html"
							}
						]
					}
				},
				"titleSsmlOverride": {
					"name": "Title SSML Override",
					"description": {
						"description": "The generated content will use this content instead of the Title content. When you generate audio files, Speech Synthesis Markup Language (SSML) is supported. SSML allows advanced control over the audio narration being created. *Note: This only works when you generate audio narration.*",
						"learnMoreLinks": [
							{
								"title": "Generating Speech from SSML Documents",
								"url": "https://docs.aws.amazon.com/polly/latest/dg/ssml.html"
							}
						]
					}
				},
				"titlePrintOverride": {
					"name": "Title Print Override",
					"description": "When you print a checklist, this title will display instead of the content in the **Title** property. Use **Paste Title** to paste the current title as a starting point."
				},
				"titleAudio": {
					"name": "Title Audio",
					"description": {
						"description": "Allows you to replace the default device text-to-speech with a recorded audio file. You can upload an MP3, reference an external URL, select and exising one from the AmbiFi Drive or generate audio from the Amazon Polly service.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"description": {
					"name": "Description",
					"description": "A description of the checklist."
				},
				"genre": {
					"name": "Genre",
					"description": "The genre of the checklist. This categorizes the checklist to make it easier to find in search."
				},
				"languageCode": {
					"name": "Language Code",
					"description": "The language code for the activity. e.g. en-US, zh-CN."
				},
				"driveRootPath": {
					"name": "Drive Root Path",
					"description": "This will be the default location in the AmbiFi Drive where assets get uploaded to."
				},
				"ignoreCompletion": {
					"name": "Ignore Completion",
					"description": "The completion status of all items in the checklist are tracked at each level in the hierarchy. Setting this will ignore completion at the checklist level."
				},
				"hideStatus": {
					"name": "Hide Status",
					"description": "The completion status of all items in the checklist are tracked at each level in the hierarchy. Setting this will track the status, but will hide the visual indication of the status at the checklist level."
				},
				"breadcrumbBarVisible": {
					"name": "Breadcrumb Bar Visible",
					"description": "Controls whether the breadcrumb bar is shown in the player."
				},
				"breadcrumbSearchBarVisibleAlways": {
					"name": "Always Show Search Bar",
					"description": "When enabled, larger screens show the search box directly in the breadcrumb bar. When disabled, users open search from the search icon."
				},
				"titleCardImage": {
					"name": "Title Card Image",
					"description": {
						"description": "The Title Card Image is an image you want to present that represents the activity. You can upload one from your local machine, reference an external URL, or reference on that you have already uploaded to the AmbiFi Drive.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"backgroundAudio": {
					"name": "Background Audio",
					"description": {
						"description": "Play background audio when a user is viewing your activity. You can upload one from your local machine, reference an external URL, or reference on that you have already uploaded to the AmbiFi Drive.\n\n*Note: If you use background audio, there are more options that will appear in the Advaned panel such as lowering the volume of the background when narration is spoken.*",
						"learnMoreLinks": [
							{
								"title": "Example Ambii with Background Audio",
								"url": "https://publications.ambifi.com/hhph/20-seconds-or-more/index.html"
							},
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"logoImageLarge": {
					"name": "Logo Image (For normal/large screens)",
					"description": {
						"description": "Upload a logo that will appear in the title bar of the application. Upload a large version and small version of the logo to accomodate different screen sizes. If you only upload one format, it will use that for all screen sizes. You can also choose if the logo should be aligned on the left or right.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"logoImageSmall": {
					"name": "Logo Image (For small screens)",
					"description": {
						"description": "Upload a logo that will appear in the title bar of the application. Upload a large version and small version of the logo to accomodate different screen sizes. If you only upload one format, it will use that for all screen sizes. You can also choose if the logo should be aligned on the left or right.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"media": {
					"name": "Media",
					"description": {
						"description": "Upload a background image for the activity. You can upload one from your local machine, reference an external URL, or reference on that you have already uploaded to the AmbiFi Drive.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"tags": {
					"name": "Tags",
					"description": "Adding any number of tags helps to categorize the checklist so that it can be more easily found in Search and the Status views."
				},
				"creator": {
					"name": "Creator",
					"description": "The original creator of the checklist. A checklist can be cloned, so this gives credit to the original author of the checklist."
				},
				"contributors": {
					"name": "Contributors",
					"description": "A list of contributors of the checklist. A checklist can be cloned, so this gives credit to people that contribute to extending the checklist."
				},
				"viewType": {
					"name": "View Type",
					"description": "Choose the default procedure view or fullscreen view to present items. This property can be inherited from Lists, Sections or Items."
				},
				"mediaFullscreenControlVisibility": {
					"name": "Media Fullscreen Control",
					"description": "Controls whether the learner-facing media fullscreen/expand button is shown for primary image and video content. This is an inherited property."
				},
				"mediaResizeToggleVisibility": {
					"name": "Media Resize Toggle",
					"description": "Controls whether the learner-facing contain/cover media resize toggle is shown for primary image and video content. This is an inherited property."
				},
				"mediaReplayControlVisibility": {
					"name": "Media Replay Control",
					"description": "Controls whether the learner-facing media replay button is shown for replayable media. Currently this applies to Ken Burns image animations. This is an inherited property."
				},
				"itemHeight": {
					"name": "Item Height [%]",
					"description": "Controls the default vertical space used by descendant items. This is an inherited property."
				},
				"videoMute": {
					"name": "Mute Video",
					"description": "Controls whether primary item videos start muted. This is an inherited property."
				},
				"videoLoop": {
					"name": "Loop Video",
					"description": "Controls whether primary item videos loop when they finish. This is an inherited property."
				},
				"videoAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Controls the default aspect ratio for primary item videos. This is an inherited property."
				},
				"videoMaximumHeight": {
					"name": "Maximum Height [% of device height]",
					"description": "Controls the default maximum height for primary item videos. This is an inherited property."
				},
				"videoShowInBackground": {
					"name": "Show Video in Background",
					"description": "Controls whether primary item videos render in the background of descendant cards. This is an inherited property."
				},
				"videoFitAvailableSpace": {
					"name": "Fit Video to Available Space",
					"description": "Controls whether foreground fullscreen videos fill the available item area instead of sizing from the configured Video Aspect Ratio. This is an inherited property."
				},
				"videoResizeMode": {
					"name": "Video Resize Mode",
					"description": "Controls how primary item videos scale. This is an inherited property."
				},
				"videoOverlayColor": {
					"name": "Video Overlay Color",
					"description": "Controls the default overlay applied to primary item videos. This is an inherited property."
				},
				"videoOverlayColorCustom": {
					"name": "Video Overlay Color (Custom)",
					"description": "Controls the custom overlay color applied when Video Overlay Color is set to Custom. This is an inherited property."
				},
				"videoBackgroundColor": {
					"name": "Video Background Color",
					"description": "Controls the background color shown behind primary item videos when the video does not fully fill its frame. Leave blank or use transparent for no letterbox color. This is an inherited property."
				},
				"imageAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Controls the default aspect ratio for primary item images. This is an inherited property."
				},
				"imageAspectRatioCustom": {
					"name": "Custom Image Aspect Ratio",
					"description": "Controls the custom aspect ratio used when Image Aspect Ratio is set to Custom. Use x:y format, for example 5:1. This is an inherited property."
				},
				"imageShowInBackground": {
					"name": "Show Image in Background",
					"description": "Controls whether primary item images render in the background of descendant cards. This is an inherited property."
				},
				"imageFitAvailableSpace": {
					"name": "Fit Image to Available Space",
					"description": "Controls whether foreground fullscreen images fill the available item area instead of sizing from the configured Image Aspect Ratio. This is an inherited property."
				},
				"imageResizeMode": {
					"name": "Image Resize Mode",
					"description": "Controls how primary item images scale. This is an inherited property."
				},
				"imageOverlayColor": {
					"name": "Image Overlay Color",
					"description": "Controls the default overlay applied to primary item images. This is an inherited property."
				},
				"imageOverlayColorCustom": {
					"name": "Image Overlay Color (Custom)",
					"description": "Controls the custom overlay color applied when Image Overlay Color is set to Custom. This is an inherited property."
				},
				"imageMaximumHeight": {
					"name": "Image Maximum Height [% of device height]",
					"description": "Controls the default maximum height for primary item images. This is an inherited property."
				},
				"fullscreenStartMode": {
					"name": "Start In Fullscreen",
					"description": "Controls the initial mobile app fullscreen state when the activity opens. User Preference leaves the current player preference alone, and users can still toggle fullscreen on or off afterward."
				},
				"fullscreenSuppressHideLabelsToggle": {
					"name": "Suppress Show/Hide Text Control",
					"description": "For fullscreen game-style procedures, hides the player control that lets users show or hide item text on fullscreen background-media screens."
				},
				"fullscreenLabelHideControl": {
					"name": "Fullscreen Text Hide Control",
					"description": "Controls whether users can hide label text on fullscreen label-only screens with background image or video. Auto allows hiding only when the item text is bottom-aligned with justifyContent: flex-end in Vertical View / Fullscreen, Vertical Fullscreen View (TikTok Style), or Fullscreen View (Game Style). This is an inherited property."
				},
				"fullscreenTransition": {
					"name": "Fullscreen Transition",
					"description": "Controls the default transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionIn": {
					"name": "Fullscreen Transition In",
					"description": "Overrides the incoming transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionOut": {
					"name": "Fullscreen Transition Out",
					"description": "Overrides the outgoing transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionDelay": {
					"name": "Fullscreen Transition Delay [ms]",
					"description": "Adds an optional delay in milliseconds before the fullscreen game-style transition begins. This is an inherited property."
				},
				"listViewMode": {
					"name": "Default List View Mode",
					"description": "Sets the default web player list presentation for this activity.\n\nChoose whether Lists start with tabs at the bottom of the screen or in collapsible panels. If you also allow user preference below, this becomes the starting default.\n\n*Note: This property is only honored in the AmbiFi Web Player. The Mobile Player always uses tabs.*"
				},
				"listTabsVisible": {
					"name": "Show bottom list tabs",
					"description": "Keep the bottom List tab bar visible while the AmbiFi Web Player is using Panels mode. Turn this off when panel navigation should be the only way to move between Lists."
				},
				"listViewModeUserPreference": {
					"name": "List View Mode Preference",
					"description": "Allow the user to switch between List and Panels under Appearance in the AmbiFi Web Player. When enabled, the Default List View Mode above is used as the starting mode."
				},
				"listBarAutoSync": {
					"name": "Auto-Sync List Bar",
					"description": "When enabled, the horizontal List bar in the AmbiFi Web Player automatically scrolls to keep the selected List centered when possible. This applies when the user selects a List directly or the selected item moves into a different List."
				},
				"listViewPanelStatusPosition": {
					"name": "Panels Status Position",
					"description": "Choose where the status indicator stripe appears when Lists are shown in Panels mode in the AmbiFi Web Player."
				},
				"defaultView": {
					"name": "Default View",
					"description": "Choose the Default View for content in a List. This property can be inhertied from Lists, Sections and Items. By selecting User Preference it allows to user to choose what type of view they prefer.\n\n*Note: The Horizontal View and Vertical Fullscreen View (TikTok Style) is only supported in the AmbiFi Mobile Player.*"
				},
				"id": {
					"name": "ID",
					"description": {
						"description": "When you want to use the linking capability, you assign an ID. Assigning an ID at the checklist level allows one checklist to link to another checklist. If using more advanced capabilities like a **Value Trigger** you also would use an ID to allow scripts to address it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251"
							},
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},
				// "singleLineCheckItems": {
				// 	"name": "Single Line Check Items",
				// 	"description": "Displays the layout of check items on a single line insttead of stacked on top of each other. The width of the checklist has to be greater than 360 before the single items will display."
				// },
				"suppressAudio": {
					"name": "Don't Speak Narration",
					"description": "Turns off audio narration for the checklist."
				},
				"itemsOnSingleLine": {
					"name": "Labels on a Single Line",
					"description": "Layout labels on one line with Label 1 on the left and Label 2 on the right with a separator in between."
				},
				"showRequiredAsterisk": {
					"name": "Show Required Asterisk",
					"description": "Shows a required indicator on fields marked Required or Mandatory without modifying authored label text."
				},
				"requiredIndicatorSymbol": {
					"name": "Required Indicator Character",
					"description": "Character or short text shown as the required indicator (for example *, !, or req)."
				},
				"requiredIndicatorColor": {
					"name": "Required Indicator Color",
					"description": "Color string for the required indicator (for example goldenrod, #b07b00, or rgb(176,123,0))."
				},
				"itemValueCommitMode": {
					"name": "Value Commit Mode",
					"description": "Controls whether changing selection to another card should behave like pressing OK on the current card.",
					"options": {
						"okOnly": "OK only (explicit submit)",
						"tapAwayIsOk": "Tap-away = OK (auto-submit on card change)"
					}
				},
				"autoScrollOnAdvance": {
					"name": "Auto-scroll On Advance",
					"description": "Automatically scroll to the next selected card when moving forward after acknowledgement."
				},
				"advanceOnAcknowledgeStrategy": {
					"name": "Advance On Acknowledge Strategy",
					"description": "Controls where the player navigates after acknowledging an item.",
					"options": {
						"nextItem": "Next item (don't skip ahead) (default)",
						"nextIncompleteItem": "Next incomplete item"
					}
				},
				"switchToShowMode": {
					"name": "Allow User to Switch to Show Mode",
					"description": {
						"description": "There are two types of procedures you can create in Ambifi. Procedure Mode is the default and presents all items as a collection of cards. Procedure Mode supports all Item Types such as Check Item, Yes/No, Picker, etc. Show Mode is a fullscreen mode that presents each item as a fullscreen slide. Show Mode only supports the Check Item.",
						"learnMoreLinks": [
							{
								"title": "Procedure Mode Example",
								"url": "https://publications.ambifi.com/covid-19/helmet-ventilation/index.html"
							},
							{
								"title": "Show Mode Example",
								"url": "https://publications.ambifi.com/ambifi/platinum-casting/index.html"
							}
						]

					}
				},
				"trackLocation": {
					"name": "Track Location",
					"description": "Enables tracking the location of your route when the checklist is running. You can review this route in the Status panel of AmbiFi Cloud. You can also track your location at a more granular level by starting and stopping tracking on items in the checklist."
				},
				"disableMediaOptimization": {
					"name": "Disable Media Optimization",
					"description": "When uploading media files, the media is optimized to run on a variety of devices. Disabling this says to not apply any optimizaitons."
				},
				"applyShowModeCustomStyles": {
					"name": "Apply custom styles to Show Mode Activity",
					"description": {
						"description": "There are a default set of styles applied when using Show Mode. Turning this on will allows you full control of the styling. Styling is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							},
							{
								"title": "Theme Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941162520/Theme+JSON"
							},
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							}
						]
					}
				},

				"globalTheme": {
					"name": "Global Theme",
					"description": {
						"description": "A Global Theme is a theme you create that all of the other activities you create can inherit. A theme defines the style information for all of the components that can appear in an activity. A theme is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "Theme Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941162520/Theme+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"dontUseGlobalOrgTheme": {
					"name": "Don't use global organization theme",
					"description": "By default an activity inherits from the Global Theme if one is defined. This option allows you to provide a theme at the activity level that doesn't inherit from the Global Theme."
				},
				"externalThemes": {
					"name": "External Themes",
					"description": {
						"description": "Besides the Global Theme, you can also create any number of themes in the AmbiFi Drive that you can reference. This allows you to create a theme you may want to re-use over a number of activities. You can also build very modular themes because any number of external theme references can be added here. It basically merges all of the ones you reference into one theme.",
						"learnMoreLinks": [
							{
								"title": "Theme Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941162520/Theme+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]

					}
				},
				"inlineTheme": {
					"name": "Inline Theme",
					"description": {
						"description": "The Inline Theme allows you to create a theme at the activity level. Themes are merged in a hierarchy, so if you have a Global Theme it will first use those propertes. It will then merge in any External Themes you may have. Finally it will merge in an Inline Theme. This allows you to override specific properties at an actvitiy level, but have most of the other properties inherited. If you want an activity to completely have its own theme, then you would set **Don't use global organization theme** ON, you wouldn't add any External Theme references and then you would add an Inline Theme.",
						"learnMoreLinks": [
							{
								"title": "Theme Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941162520/Theme+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},

				"globalStylesheet": {
					"name": "Global Stylesheet",
					"description": {
						"description": "A Global Stylesheet is a stylesheet that all other activities you create can inherit from. A stylesheet defines the style information for specific items in the outline you are createing for an activity. For example, you can set the font information for all items or change the background color of each section header. A stylesheet is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoireLinks": [
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"dontUseGlobalOrgStylesheet": {
					"name": "Don't use global organization stylesheet",
					"description": "By default an activity inherits from the Global Stylesheet if one is defined. This option allows you to provide a stylesheet at the activity level that doesn't inherit from the Global Stylesheet."
				},
				"externalStylesheets": {
					"name": "External Stylesheets",
					"description": {
						"description": "Besides the Global Stylesheet, you can also create any number of stylesheets in the AmbiFi Drive that you can reference. This allows you to create a stylesheet you may want to re-use over a number of activities. You can also build very modular stylesheets because any number of external stylesheet references can be added here. It basically merges all of the ones you reference into one stylesheet.",
						"learnMoreLinks": [
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"inlineStylesheet": {
					"name": "Inline Stylesheet",
					"description": {
						"description": "The Inline Stylesheet allows you to create a stylesheet at the activity level. Stylesheets are merged in a hierarchy, so if you have a Global Stylesheet it will first use those propertes. It will then merge in any External Stylesheets you may have. Finally it will merge in an Inline Stylesheet. This allows you to override specific properties at an actvitiy level, but have most of the other properties inherited. If you want an activity to completely have its own stylesheet, then you would set **Don't use global organization styelsheet** ON, you wouldn't add any External Stylesheet references and then you would add an Inline Stylesheet.",
						"learnMoreLinks": [
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"stylesCss": {
					"name": "CSS",
					"description": {
						"description": "Add CSS in the form of a JSON object to set style information on specific items in the outline you are creating for an activity. For example, you can set the font information for all items or change the background color of each section header. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"classes": {
					"name": "Classes",
					"description": {
						"description": "Reference classes you create in a stylesheet. For example you can create a class .warning-box and then reference it from any item. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"fonts": {
					"name": "Fonts",
					"description": "Provide font definitions to define different fonts you want to utilize in an activity. You can copy/paste the URL of a font definition from Google Fonts."
				},
				"customTemplate": {
					"name": "Custom Template",
					"description": {
						"description": "A Custom Template to use for printing. The template uses the JsRender templating language. You can paste a template from a variety of base templates provided.",
						"learnMoreLinks": [
							{
								"title": "JsRender",
								"url": "https://www.jsviews.com/"
							}
						]
					}
				},
				"contentModel": {
					"name": "Content Model",
					"description": "The **Content Model** is the JSON representation of the checklist. When creating a print template, the model is a datasource for the template that you recurse through to generate a print document."
				},
				"customProperties": {
					"name": "Custom Properties (JSON Format)",
					"description": "You can supply custom properties in JSON format that get merged in with the content model. This allows you to extend the base content model for this checklist."
				},
				"relatedItems": {
					"name": "Related Items",
					"description": "Associate any number of related items with a List, Section or Item. If you associated them with a List or Section then the related item will appear for every item in those containers. Related items will appear in a side panel on the right. This allows an author to add some links whenever a user navigates through an activity and provides some extra context and knowledge."
				},
				"authorProperties": {
					"name": "Author Properties",
					"description": "These are advanced properties that can be set at different levels in the authoring hierarchy."
				},
				"functions": {
					"name": "Functions Editor",
					"description": {
						"description": "Functions allows javascript code to be created that can be utilized at runtime when the checklist is running.",
						"learnMoreLinks": [
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},
				"itemButtonOkLabel": {
					"name": "Button Label",
					"description": "Change the label of the OK buttton. The OK button is displayed on a Check Item if you select the Label Only option for the Check Item. It also appears on other item types to move on after accepting a value. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemButtonBackLabel": {
					"name": "Back Button Label",
					"description": "Change the label of the Back button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use when Back Button Visibility resolves to Visible and a previous visible item exists."
				},
				"itemButtonNotApplicableLabel": {
					"name": "N/A Button Label",
					"description": "Change the label of the N/A button. This is an inherited property. You can define it at any level in the outline so child items use the same label when N/A Button Visibility resolves to Visible."
				},
				"itemButtonOkVisibility": {
					"name": "Visibility",
					"description": "Change the visibility of the OK button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) this visibility."
				},
				"itemButtonBackVisibility": {
					"name": "Back Button Visibility",
					"description": "Controls whether the Back button can appear for item OK footers. This is an inherited property. When set to Visible, the player will show Back when a previous visible item exists."
				},
				"itemButtonNotApplicableVisibility": {
					"name": "N/A Button Visibility",
					"description": "Controls whether the N/A button can appear in the item footer. This is an inherited property. When set to Visible, the player lets the user mark the current item as not applicable without entering a value."
				},
				"itemButtonOkPendingBehavior": {
					"name": "Pending Behavior",
					"description": "Controls how the OK button behaves before an item is ready to submit. Choose between keeping it visible but disabled, or hiding it until the item is ready."
				},
				"fullscreenActionVariant": {
					"name": "Fullscreen Variant",
					"description": "In fullscreen modes, choose whether items use the classic footer bar or the modern floating action variant. This is an inherited property."
				},
				"fullscreenActionPlacement": {
					"name": "Fullscreen Placement",
					"description": "When a fullscreen action variant is active, choose whether the fullscreen actions stay pinned as an overlay or stay pinned below the content area. This is an inherited property."
				},
				"fullscreenActionFlowWhenScrollable": {
					"name": "Flow With Content When Scrollable",
					"description": "When enabled, fullscreen actions use the selected pinned placement while the content fits on screen, but move to the end of the content once the content needs to scroll. This is an inherited property."
				},
				"fullscreenSwipeNavigation": {
					"name": "Fullscreen Swipe Navigation",
					"description": "Controls whether fullscreen label-only screens can use swipe up and swipe down for navigation when the screen is not scrollable and does not have blocking animation behavior. This is an inherited property."
				},
				"fullscreenSwipeSound": {
					"name": "Fullscreen Swipe Sound",
					"description": "Controls whether fullscreen swipe navigation plays the whoosh sound effect when a swipe navigation gesture succeeds. Auto disables the sound in Vertical Fullscreen View (TikTok Style) and enables it in other fullscreen vertical views. This is an inherited property."
				},
				"fullscreenLabelHideControl": {
					"name": "Fullscreen Text Hide Control",
					"description": "Controls whether users can hide label text on fullscreen label-only screens with background image or video. Auto allows hiding only when the item text is bottom-aligned with justifyContent: flex-end in Vertical View / Fullscreen, Vertical Fullscreen View (TikTok Style), or Fullscreen View (Game Style). This is an inherited property."
				},
				"fullscreenActionNavAlignment": {
					"name": "Fullscreen Nav Alignment",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary navigation cluster stays left-aligned or centered within the available footer lane while utility controls remain on the right. This is an inherited property."
				},
				"fullscreenActionNavOrder": {
					"name": "Fullscreen Nav Order",
					"description": "When fullscreen navigation shows both the primary action and Back, choose whether the primary action appears first or Back appears first. This is an inherited property."
				},
				"fullscreenActionStyle": {
					"name": "Fullscreen Floating Style",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary action is emphasized with a filled color or kept minimal on the shared surface. This is an inherited property."
				},
				"fullscreenActionPrimaryColor": {
					"name": "Floating Primary Color",
					"description": "Set the fill color used by the emphasized primary fullscreen floating action, such as Next. This is an inherited property."
				},
				"fullscreenActionSurfaceColor": {
					"name": "Floating Surface Color",
					"description": "Set the shared surface color used by fullscreen floating action capsules such as the primary navigation cluster and More button. This is an inherited property."
				},
				"fullscreenActionToolBackgroundColor": {
					"name": "Tool Background Color",
					"description": "Set the background color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to reuse the floating surface color. This is an inherited property."
				},
				"fullscreenActionToolForegroundColor": {
					"name": "Tool Foreground Color",
					"description": "Set the text and icon color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to auto-contrast against the tool background color. This is an inherited property."
				},
				"itemCommentsLabel": {
					"name": "More Button Label",
					"description": "Change the label of the Comments buttton. The Comments button is displayed on an Item if there are comments added from the author and the Comments Visibility is set to TRUE. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemCommentsIcon": {
					"name": "More Button Icon",
					"description": "Use a Font Awesome icon name for the More button. This is an inherited property."
				},
				"itemCommentsBackgroundColor": {
					"name": "More Button Background Color",
					"description": "Set the background color used by the More button. Leave blank to use the smart default blue fill derived from the fullscreen primary color. This is an inherited property."
				},
				"itemCommentsForegroundColor": {
					"name": "More Button Foreground Color",
					"description": "Set the text and icon color used by the More button. Leave blank to auto-contrast against the More button background color. This is an inherited property."
				},
				"itemRelatedItemsLabel": {
					"name": "Related Button Label",
					"description": "Change the label of the Related Items buttton. The Related Items button is displayed on an Item if you associated Related Items. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemRelatedItemsIcon": {
					"name": "Related Button Icon",
					"description": "Use a Font Awesome icon name for the Related button. This is an inherited property."
				},
				"itemRelatedItemsBackgroundColor": {
					"name": "Related Button Background Color",
					"description": "Set the background color used by the Related button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemRelatedItemsForegroundColor": {
					"name": "Related Button Foreground Color",
					"description": "Set the text and icon color used by the Related button. Leave blank to auto-contrast against the Related button background color. This is an inherited property."
				},
				"itemAttachmentsLabel": {
					"name": "Attachments Button Label",
					"description": "Change the label of the Attachments button. Leave blank to show no label by default. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemAttachmentsIcon": {
					"name": "Attachments Button Icon",
					"description": "Use a Font Awesome icon name for the Attachments button. This is an inherited property."
				},
				"itemAttachmentsBackgroundColor": {
					"name": "Attachments Button Background Color",
					"description": "Set the background color used by the Attachments button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemAttachmentsForegroundColor": {
					"name": "Attachments Button Foreground Color",
					"description": "Set the text and icon color used by the Attachments button. Leave blank to auto-contrast against the Attachments button background color. This is an inherited property."
				},
				"submitButtonLabel": {
					"name": "Submit Button Label",
					"description": "Change the label of the subbmit button. The submit buttton appears on activities that you assign to other users."
				},
				"contentModelReferences": {
					"name": "Content Model References",
					"description": "A reference to a Content Model."
				},
				"dataSources": {
					"name": "Data Sources",
					"description": "A Data Source is a JSON file of external data or content that other item types can reference."
				},
				"defaultColumnWidth": {
					"name": "Default Column Width",
					"description": "Sets the default column width of the section. This is an inherited proeprty. You can set this property at any level of the outline (Activity, List, Section) and all the children in the container can inherit or override."
				},
				"defaultFocusedMode": {
					"name": "Default Focused Mode",
					"description": "Focused mode highlights the current item and presents all other items a disabled look so the user can focus on the currently selected item. This is an inherited proeprty. You can set this property at any level of the outline (Activity, List, Section) and all the children in the container can inherit or override."
				},
				"defaultAlwaysMoveForward": {
					"name": "Default Always Move Forward",
					"description": "Controls whether navigation automatically continues when the next target is outside an incomplete section. When Off, the player asks whether to return to an unchecked item in that section or move forward. User Preference uses the player's Always Move Forward setting, which defaults On. Lists and sections can inherit or override this value."
				},
				"checkbarVisibility": {
					"name": "Checkbar Visibility",
					"description": "Determines if the Checkbar should be visible for the user. The Checkbar provides a toolbar that allows a user to Check, Skip, Locate and toggle voice recognition on/off."
				},
				"backgroundAudioDuckingDuck": {
					"name": "Duck Background Audio",
					"description": "This will reduce the volume of the background audio while Mira is speaking, also while video is playing with volume."
				},
				"backgroundAudioDuckingDuration": {
					"name": "Ducking Duration [ms]",
					"description": "How fast would you like ducking to occur, in milliseconds (1000 milliseconds = 1 second)."
				},
				"backgroundAudioDuckingVolume": {
					"name": "Ducking Volume [%]",
					"description": "Select a volume that will be ducked to when voice narration or video starts."
				},
				"userNotesVisibility": {
					"name": "User Notes Visibility",
					"description": "Any item can allow a user to attach their own notes. These notes become part of the history of the activity and can be viewed from the Status panel in AmbiFi Cloud. This allows you to set what items you would allow a user to capture notes. This is an inherited propertty. If you set it visible here, and you set all other items to inherit this, then every item will allow the user to add notes."
				},
				"aiAssistant": {
					"name": "Enable AI Assistant",
					"description": "You can enable an AI assistant to help you create your content. This will allow you to upload a file such as a PDF or Word document which your assistant can help make sense of."
				}
			}
		}
	},
	"list": {
		"menu": "Add List (Optional)",
		"title": "List",
		"description": "A List is a container for Sections. You can add multiple Sections. Think of it as a chapter in a book.",
		"properties": {
			"properties": {
				"title": {
					"name": "Title",
					"description": "The **Title** of the List."
				},
				"titleNarrationOverride": {
					"name": "Title Narration Override",
					"description": {
						"description": "Mira will read this content instead of the content in the **Title** property. Use **Paste Title** to paste the current title as a starting point.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Enhancing Pronunciation",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/tts-phonetics/index.html"
							}
						]
					}
				},
				"titleSsmlOverride": {
					"name": "Title SSML Override",
					"description": {
						"description": "The generated content will use this content instead of the Title content. When you generate audio files, Speech Synthesis Markup Language (SSML) is supported. SSML allows advanced control over the audio narration being created. *Note: This only works when you generate audio narration.*",
						"learnMoreLinks": [
							{
								"title": "Generating Speech from SSML Documents",
								"url": "https://docs.aws.amazon.com/polly/latest/dg/ssml.html"
							}
						]
					}
				},
				"titlePrintOverride": {
					"name": "Title Print Override",
					"description": "When you print a checklist, this title will display instead of the content in the **Title** property. Use **Paste Title** to paste the current title as a starting point."
				},
				"titleAudio": {
					"name": "Title Audio",
					"description": {
						"description": "Allows you to replace the default device text-to-speech with a recorded audio file. You can upload an MP3, reference an external URL, select and exising one from the AmbiFi Drive or generate audio from the Amazon Polly service.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"suppressAudioTitle": {
					"name": "Don't Speak Title",
					"description": "Mira will not read the title."
				},
				"dontReadTitleSuffix": {
					"name": "Don't Add \"List\" When Reading Title",
					"description": "Mira will not read the word \"List\" after reading the title of the List."
				},
				"dontShowInNavigationTreeView": {
					"name": "Don't Show in Navigation Tree View",
					"description": "In the Breadcrumb View, there is a navigation tree view of the entire activity. This hides the List from that view."
				},

				"id": {
					"name": "ID (An ID is required for any Item you want to target with Visible If... or any Item you want to link to)",
					"description": {
						"description": "Assigning an ID at the List level allows you to target the List for Visible If... or linking. If using more advanced capabilities like a **Value Trigger** you also would use an ID to allow scripts to address it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Visible If...",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/visible-if/index.html"
							},
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251"
							},
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},
				"visible": {
					"name": "Visible",
					"description": "Enables you to determine if you want the List initially visible or not. You can use this in conjunction with scripting to make the List appear dynamically."
				},
				"visibleIf": {
					"name": "Visible If...",
					"description": {
						"description": "Visible If lets you show or hide this item based on a true/false rule. Pick another component in the dropdown and build a condition: if the rule is true, this item shows; if false, it hides. Components normally need an ID to be referenced—set one on the target component first. If you don’t see it, turn on “Show all” to include every node; selecting one without an ID will auto-assign it. Use the sort (Outline/Alphabetical) and “Show IDs” toggles to navigate large trees, or switch to Advanced to edit the full Boolean expression directly (AND/OR groups, comparisons).",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Visible If...",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/visible-if/index.html"
							}
						]
					}
				},
				"visibleIfComponentWithId": {
					"name": "...the following component with ID:",
					"description": {
						"description": "To target another component you can either use the normal list, which shows components that already have an ID you set manually, or turn on “Show all,” which includes components without IDs and auto-assigns an ID when you select one. For example, to drive visibility from a Yes/No question, either set an ID on that question so it appears in the normal list, or enable “Show all” and select it to auto-assign an ID.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Visible If...",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/visible-if/index.html"
							}
						]
					}
				},
				"visibleIfAdvanced": {
					"name": "Switch to Advanced Visible If...",
					"description": "Switch to the Advanced Visible If... view. This allows advanced expressions to be created that the normal view doesn't support."
				},
				"repeatable": {
					"name": "Repeatable",
					"description": "Determines if the list is repeatable. If marked repeatable, you can add a Link Action to clone the item."
				},
				"repeatableRetainValues": {
					"name": "Repeatable Retain Values",
					"description": "By default, all items values are reset when you repeat. By checking this option you can retain values the user entered. This is a good option to do comparison scenarios."
				},
				"repeatableIndex": {
					"name": "Repeatable Index",
					"description": "The index of the repeatable list."
				},
				"repeatableInitialCount": {
					"name": "Repeatable Initial Count",
					"description": "The number of repeatable lists to initially display when the activity starts."
				},
				"repeatableMaxCount": {
					"name": "Repeatable Max Count",
					"description": "The maximum number of repeatable lists to display."
				},

				"ignoreCompletion": {
					"name": "Ignore Completion",
					"description": "The completion status of all items in the checklist are tracked at each level in the hierarchy. Setting this will ignore completion at the List level."
				},
				"hideStatus": {
					"name": "Hide Status",
					"description": "The completion status of all items in the checklist are tracked at each level in the hierarchy. Setting this will track the status, but will hide the visual indication of the status at the List level."
				},

				"media": {
					"name": "Media",
					"description": {
						"description": "Upload a background image for the List. You can upload one from your local machine, reference an external URL, or reference on that you have already uploaded to the AmbiFi Drive.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},

				"viewType": {
					"name": "View Type",
					"description": "Allows you to choose the default procedure view or fullscreen view to present items. This property can be inherited from Lists, Sections or Items."
				},
				"mediaFullscreenControlVisibility": {
					"name": "Media Fullscreen Control",
					"description": "Controls whether the learner-facing media fullscreen/expand button is shown for primary image and video content. This is an inherited property."
				},
				"mediaResizeToggleVisibility": {
					"name": "Media Resize Toggle",
					"description": "Controls whether the learner-facing contain/cover media resize toggle is shown for primary image and video content. This is an inherited property."
				},
				"mediaReplayControlVisibility": {
					"name": "Media Replay Control",
					"description": "Controls whether the learner-facing media replay button is shown for replayable media. Currently this applies to Ken Burns image animations. This is an inherited property."
				},
				"itemHeight": {
					"name": "Item Height [%]",
					"description": "Controls the default vertical space used by descendant items. This is an inherited property."
				},
				"videoMute": {
					"name": "Mute Video",
					"description": "Controls whether primary item videos start muted. This is an inherited property."
				},
				"videoLoop": {
					"name": "Loop Video",
					"description": "Controls whether primary item videos loop when they finish. This is an inherited property."
				},
				"videoAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Controls the default aspect ratio for primary item videos. This is an inherited property."
				},
				"videoMaximumHeight": {
					"name": "Maximum Height [% of device height]",
					"description": "Controls the default maximum height for primary item videos. This is an inherited property."
				},
				"videoShowInBackground": {
					"name": "Show Video in Background",
					"description": "Controls whether primary item videos render in the background of descendant cards. This is an inherited property."
				},
				"videoFitAvailableSpace": {
					"name": "Fit Video to Available Space",
					"description": "Controls whether foreground fullscreen videos fill the available item area instead of sizing from the configured Video Aspect Ratio. This is an inherited property."
				},
				"videoResizeMode": {
					"name": "Video Resize Mode",
					"description": "Controls how primary item videos scale. This is an inherited property."
				},
				"videoOverlayColor": {
					"name": "Video Overlay Color",
					"description": "Controls the default overlay applied to primary item videos. This is an inherited property."
				},
				"videoOverlayColorCustom": {
					"name": "Video Overlay Color (Custom)",
					"description": "Controls the custom overlay color applied when Video Overlay Color is set to Custom. This is an inherited property."
				},
				"videoBackgroundColor": {
					"name": "Video Background Color",
					"description": "Controls the background color shown behind primary item videos when the video does not fully fill its frame. Leave blank or use transparent for no letterbox color. This is an inherited property."
				},
				"imageAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Controls the default aspect ratio for primary item images. This is an inherited property."
				},
				"imageAspectRatioCustom": {
					"name": "Custom Image Aspect Ratio",
					"description": "Controls the custom aspect ratio used when Image Aspect Ratio is set to Custom. Use x:y format, for example 5:1. This is an inherited property."
				},
				"imageShowInBackground": {
					"name": "Show Image in Background",
					"description": "Controls whether primary item images render in the background of descendant cards. This is an inherited property."
				},
				"imageFitAvailableSpace": {
					"name": "Fit Image to Available Space",
					"description": "Controls whether foreground fullscreen images fill the available item area instead of sizing from the configured Image Aspect Ratio. This is an inherited property."
				},
				"imageResizeMode": {
					"name": "Image Resize Mode",
					"description": "Controls how primary item images scale. This is an inherited property."
				},
				"imageOverlayColor": {
					"name": "Image Overlay Color",
					"description": "Controls the default overlay applied to primary item images. This is an inherited property."
				},
				"imageOverlayColorCustom": {
					"name": "Image Overlay Color (Custom)",
					"description": "Controls the custom overlay color applied when Image Overlay Color is set to Custom. This is an inherited property."
				},
				"imageMaximumHeight": {
					"name": "Image Maximum Height [% of device height]",
					"description": "Controls the default maximum height for primary item images. This is an inherited property."
				},
				"fullscreenTransition": {
					"name": "Fullscreen Transition",
					"description": "Controls the default transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionIn": {
					"name": "Fullscreen Transition In",
					"description": "Overrides the incoming transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionOut": {
					"name": "Fullscreen Transition Out",
					"description": "Overrides the outgoing transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionDelay": {
					"name": "Fullscreen Transition Delay [ms]",
					"description": "Adds an optional delay in milliseconds before the fullscreen game-style transition begins. This is an inherited property."
				},
				"defaultView": {
					"name": "Default View",
					"description": "Choose the Default View for content in a List. This property can be inhertied from Lists, Sections and Items. By selecting User Preference it allows to user to choose what type of view they prefer.\n\n*Note: The Horizontal View and Vertical Fullscreen View (TikTok Style) is only supported in the AmbiFi Mobile Player.*"
				},
				"startInBirdseyeView": {
					"name": "Start in Birdseye View",
					"description": "Starts the List in Birdseye View when you navigate to it. Birdseye View presents a set of large buttons for each section to make a choice of what content you want to navigate to."
				},

				"fontColor": {
					"name": "Font Color",
					"description": "Select a font color for the List title."
				},
				"iconColor": {
					"name": "Icon Color",
					"description": "Select an icon color for the List. A List title can have an icon displayed before the title. In the Advanced section you can set the icon to display."
				},
				"backgroundColor": {
					"name": "Background Color",
					"description": "Select a background color for the List title. This will change the color of the tab or header for the List."
				},
				"borderColor": {
					"name": "Border Color",
					"description": "Select a border color for the List title."
				},

				"stylesCss": {
					"name": "Styles",
					"description": {
						"description": "Add CSS in the form of a JSON object to set style information on specific items in the outline you are creating for an activity. For example, you can set the font information for all items or change the background color of each section header. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"classes": {
					"name": "Classes",
					"description": {
						"description": "Reference classes you create in a stylesheet. For example you can create a class .warning-box and then reference it from any item. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},

				// Print Properties
				"keepTogether": {
					"name": "Keep Together",
					"description": "Keep Together attempts to keep the List and all children on the same page."

				},
				"breakBefore": {
					"name": "Break Before",
					"description": "Breaks the page before this List."
				},
				"breakBeforeHeight": {
					"name": "Break Before Height",
					"description": "Creates an area with the height specified before the break."
				},
				"breakAfter": {
					"name": "Break After",
					"description": "Breaks the page after the List."
				},
				"breakAfterHeight": {
					"name": "Break After Height",
					"description": "Creates an area with the height after the break."

				},
				"customProperties": {
					"name": "Custom Properties (JSON Format)",
					"description": "You can supply custom properties in JSON format that get merged in with the content model. This allows you to extend the base content model for this List."
				},

				"relatedItems": {
					"name": "Related Items",
					"description": "Associate any number of related items with a List, Section or Item. If you associated them with a List or Section then the related item will appear for every item in those containers. Related items will appear in a side panel on the right. This allows an author to add some links whenever a user navigates through an activity and provides some extra context and knowledge."
				},

				"filterTags": {
					"name": "Filter Tags",
					"description": "**Filter Tags** is a feature that allows you to filter your activity when it is launched. Enter tags such as Beginner, or Advanced. When you tag something you are saying you want the option to hide or show the List when the activity runs. Lists that are not tagged will always show, and many of your Lists would not be tagged. But if you have a specific List you want to display like content to show if you are a beginner, then tag that Beginner."

				},
				"groupNames": {
					"name": "Group Names",
					"description": "**Group Names** allow you to group a number of Lists. This can be used with scripting to apply operations on a number of items."

				},

				"suppressAudio": {
					"name": "Don't Speak Narration",
					"description": "Mira will not read audio in this List."
				},
				"suppressCompletionConfirmation": {
					"name": "Don't Speak Completion Confirmation",
					"description": "Normally Mira speaks when the List is completed. This suppresses that."
				},
				"suppressPrint": {
					"name": "Don't Print",
					"description": "Excludes the List when the checklist is printed."
				},
				"authorProperties": {
					"name": "Author Properties",
					"description": "These are advanced properties that can be set at different levels in the authoring hierarchy."
				},
				"iconType": {
					"name": "Icon Type",
					"description": {
						"description": "You can upload an image as an icon or use a Font Awesome icon name. e.g. info-cirlce.",
						"learnMoreLinks": [
							{
								"title": "Search Font Awesome",
								"url": "https://fontawesome.com/"
							},
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"iconImage": {
					"name": "Icon Image",
					"description": {
						"description": "Upload an image to use as an icon. It is recommended to use a small SVG, JPEG or PNG file.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"iconName": {
					"name": "Icon Name",
					"description": {
						"description": "Use a Font Awesome icon name. e.g. info-cirlce.",
						"learnMoreLinks": [
							{
								"title": "Search Font Awesome",
								"url": "https://fontawesome.com/"
							}
						]
					}
				},
				"itemButtonOkLabel": {
					"name": "Button Label",
					"description": "Change the label of the OK buttton. The OK button is displayed on a Check Item if you select the Label Only option for the Check Item. It also appears on other item types to move on after accepting a value. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemButtonBackLabel": {
					"name": "Back Button Label",
					"description": "Change the label of the Back button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use when Back Button Visibility resolves to Visible and a previous visible item exists."
				},
				"itemButtonNotApplicableLabel": {
					"name": "N/A Button Label",
					"description": "Change the label of the N/A button. This is an inherited property. You can define it at any level in the outline so child items use the same label when N/A Button Visibility resolves to Visible."
				},
				"itemButtonOkVisibility": {
					"name": "Visibility",
					"description": "Change the visibility of the OK button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) this visibility."
				},
				"itemButtonBackVisibility": {
					"name": "Back Button Visibility",
					"description": "Controls whether the Back button can appear for item OK footers. This is an inherited property. When set to Visible, the player will show Back when a previous visible item exists."
				},
				"itemButtonNotApplicableVisibility": {
					"name": "N/A Button Visibility",
					"description": "Controls whether the N/A button can appear in the item footer. This is an inherited property. When set to Visible, the player lets the user mark the current item as not applicable without entering a value."
				},
				"itemButtonOkPendingBehavior": {
					"name": "Pending Behavior",
					"description": "Controls how the OK button behaves before an item is ready to submit. Choose between keeping it visible but disabled, or hiding it until the item is ready."
				},
				"fullscreenActionVariant": {
					"name": "Fullscreen Variant",
					"description": "In fullscreen modes, choose whether items use the classic footer bar or the modern floating action variant. This is an inherited property."
				},
				"fullscreenActionPlacement": {
					"name": "Fullscreen Placement",
					"description": "When a fullscreen action variant is active, choose whether the fullscreen actions stay pinned as an overlay or stay pinned below the content area. This is an inherited property."
				},
				"fullscreenActionFlowWhenScrollable": {
					"name": "Flow With Content When Scrollable",
					"description": "When enabled, fullscreen actions use the selected pinned placement while the content fits on screen, but move to the end of the content once the content needs to scroll. This is an inherited property."
				},
				"fullscreenSwipeNavigation": {
					"name": "Fullscreen Swipe Navigation",
					"description": "Controls whether fullscreen label-only screens can use swipe up and swipe down for navigation when the screen is not scrollable and does not have blocking animation behavior. This is an inherited property."
				},
				"fullscreenSwipeSound": {
					"name": "Fullscreen Swipe Sound",
					"description": "Controls whether fullscreen swipe navigation plays the whoosh sound effect when a swipe navigation gesture succeeds. Auto disables the sound in Vertical Fullscreen View (TikTok Style) and enables it in other fullscreen vertical views. This is an inherited property."
				},
				"fullscreenLabelHideControl": {
					"name": "Fullscreen Text Hide Control",
					"description": "Controls whether users can hide label text on fullscreen label-only screens with background image or video. Auto allows hiding only when the item text is bottom-aligned with justifyContent: flex-end in Vertical View / Fullscreen, Vertical Fullscreen View (TikTok Style), or Fullscreen View (Game Style). This is an inherited property."
				},
				"fullscreenActionNavAlignment": {
					"name": "Fullscreen Nav Alignment",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary navigation cluster stays left-aligned or centered within the available footer lane while utility controls remain on the right. This is an inherited property."
				},
				"fullscreenActionNavOrder": {
					"name": "Fullscreen Nav Order",
					"description": "When fullscreen navigation shows both the primary action and Back, choose whether the primary action appears first or Back appears first. This is an inherited property."
				},
				"fullscreenActionStyle": {
					"name": "Fullscreen Floating Style",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary action is emphasized with a filled color or kept minimal on the shared surface. This is an inherited property."
				},
				"fullscreenActionPrimaryColor": {
					"name": "Floating Primary Color",
					"description": "Set the fill color used by the emphasized primary fullscreen floating action, such as Next. This is an inherited property."
				},
				"fullscreenActionSurfaceColor": {
					"name": "Floating Surface Color",
					"description": "Set the shared surface color used by fullscreen floating action capsules such as the primary navigation cluster and More button. This is an inherited property."
				},
				"fullscreenActionToolBackgroundColor": {
					"name": "Tool Background Color",
					"description": "Set the background color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to reuse the floating surface color. This is an inherited property."
				},
				"fullscreenActionToolForegroundColor": {
					"name": "Tool Foreground Color",
					"description": "Set the text and icon color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to auto-contrast against the tool background color. This is an inherited property."
				},
				"itemCommentsLabel": {
					"name": "More Button Label",
					"description": "Change the label of the Comments buttton. The Comments button is displayed on an Item if there are comments added from the author and the Comments Visibility is set to TRUE. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemCommentsIcon": {
					"name": "More Button Icon",
					"description": "Use a Font Awesome icon name for the More button. This is an inherited property."
				},
				"itemCommentsBackgroundColor": {
					"name": "More Button Background Color",
					"description": "Set the background color used by the More button. Leave blank to use the smart default blue fill derived from the fullscreen primary color. This is an inherited property."
				},
				"itemCommentsForegroundColor": {
					"name": "More Button Foreground Color",
					"description": "Set the text and icon color used by the More button. Leave blank to auto-contrast against the More button background color. This is an inherited property."
				},
				"itemRelatedItemsLabel": {
					"name": "Related Button Label",
					"description": "Change the label of the Related Items buttton. The Related Items button is displayed on an Item if you associated Related Items. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemRelatedItemsIcon": {
					"name": "Related Button Icon",
					"description": "Use a Font Awesome icon name for the Related button. This is an inherited property."
				},
				"itemRelatedItemsBackgroundColor": {
					"name": "Related Button Background Color",
					"description": "Set the background color used by the Related button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemRelatedItemsForegroundColor": {
					"name": "Related Button Foreground Color",
					"description": "Set the text and icon color used by the Related button. Leave blank to auto-contrast against the Related button background color. This is an inherited property."
				},
				"itemAttachmentsLabel": {
					"name": "Attachments Button Label",
					"description": "Change the label of the Attachments button. Leave blank to show no label by default. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemAttachmentsIcon": {
					"name": "Attachments Button Icon",
					"description": "Use a Font Awesome icon name for the Attachments button. This is an inherited property."
				},
				"itemAttachmentsBackgroundColor": {
					"name": "Attachments Button Background Color",
					"description": "Set the background color used by the Attachments button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemAttachmentsForegroundColor": {
					"name": "Attachments Button Foreground Color",
					"description": "Set the text and icon color used by the Attachments button. Leave blank to auto-contrast against the Attachments button background color. This is an inherited property."
				},
				"defaultColumnWidth": {
					"name": "Default Column Width",
					"description": "Sets the default column width of the section. This is an inherited proeprty. You can set this property at any level of the outline (Activity, List, Section) and all the children in the container can inherit or override."
				},
				"defaultFocusedMode": {
					"name": "Default Focused Mode",
					"description": "Focused mode highlights the current item and presents all other items a disabled look so the user can focus on the currently selected item. This is an inherited proeprty. You can set this property at any level of the outline (Activity, List, Section) and all the children in the container can inherit or override."
				},
				"defaultAlwaysMoveForward": {
					"name": "Default Always Move Forward",
					"description": "Controls whether navigation automatically continues when the next target is outside an incomplete section. When Off, the player asks whether to return to an unchecked item in that section or move forward. User Preference uses the player's Always Move Forward setting, which defaults On. Lists and sections can inherit or override this value."
				},
				"userNotesVisibility": {
					"name": "User Notes Visibility",
					"description": "Any item can allow a user to attach their own notes. These notes become part of the history of the activity and can be viewed from the Status panel in AmbiFi Cloud. This allows you to set what items you would allow a user to capture notes. This is an inherited propertty. If you set it visible here, and you set all other items to inherit this, then every item will allow the user to add notes."
				}
			}
		}
	},
	"section": {
		"menu": "Add Section (Optional)",
		"title": "Section",
		"description": "A Section is a container for Items. You can add multiple Items. Think of it as a section in a chapter.",
		"properties": {
			"properties": {
				"title": {
					"name": "Title",
					"description": "The **Title** of the Section."
				},
				"titleNarrationOverride": {
					"name": "Title Narration Override",
					"description": {
						"description": "Mira will read this content instead of the content in the **Title** property. Use **Paste Title** to paste the current title as a starting point.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Enhancing Pronunciation",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/tts-phonetics/index.html"
							}
						]
					}
				},
				"titleSsmlOverride": {
					"name": "Title SSML Override",
					"description": {
						"description": "The generated content will use this content instead of the Title content. When you generate audio files, Speech Synthesis Markup Language (SSML) is supported. SSML allows advanced control over the audio narration being created. *Note: This only works when you generate audio narration.*",
						"learnMoreLinks": [
							{
								"title": "Generating Speech from SSML Documents",
								"url": "https://docs.aws.amazon.com/polly/latest/dg/ssml.html"
							}
						]
					}
				},
				"titlePrintOverride": {
					"name": "Title Print Override",
					"description": "When you print a checklist, this title will display instead of the content in the **Title** property. Use **Paste Title** to paste the current title as a starting point."
				},
				"titleAudio": {
					"name": "Title Audio",
					"description": {
						"description": "Allows you to replace the default device text-to-speech with a recorded audio file. You can upload an MP3, reference an external URL, select and exising one from the AmbiFi Drive or generate audio from the Amazon Polly service.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"suppressAudioTitle": {
					"name": "Don't Speak Title",
					"description": "Mira will not read the title."
				},
				"dontReadTitleSuffix": {
					"name": "Don't Add \"Section\" When Reading Title",
					"description": "Mira will not read the word \"Section\" after reading the title of the Section."
				},
				"dontShowInNavigationTreeView": {
					"name": "Don't Show in Navigation Tree View",
					"description": "In the Breadcrumb View, there is a navigation tree view of the entire activity. This hides the Section from that view."
				},

				"id": {
					"name": "ID (An ID is required for any Item you want to target with Visible If... or any Item you want to link to)",
					"description": {
						"description": "Assigning an ID at the Section level allows you to target the Section for Visible If... or linking. If using more advanced capabilities like a **Value Trigger** you also would use an ID to allow scripts to address it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Visible If...",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/visible-if/index.html"
							},
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251"
							},
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},
				"visible": {
					"name": "Visible",
					"description": "Enables you to determine if you want the Section initially visible or not. You can use this in conjunction with scripting to make the Section appear dynamically."
				},
				"visibleIf": {
					"name": "Visible If...",
					"description": {
						"description": "Visible If lets you show or hide this item based on a true/false rule. Pick another component in the dropdown and build a condition: if the rule is true, this item shows; if false, it hides. Components normally need an ID to be referenced—set one on the target component first. If you don’t see it, turn on “Show all” to include every node; selecting one without an ID will auto-assign it. Use the sort (Outline/Alphabetical) and “Show IDs” toggles to navigate large trees, or switch to Advanced to edit the full Boolean expression directly (AND/OR groups, comparisons).",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Visible If...",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/visible-if/index.html"
							}
						]
					}
				},
				"visibleIfComponentWithId": {
					"name": "...the following component with ID:",
					"description": "To target another component you can either use the normal list, which shows components that already have an ID you set manually, or turn on “Show all,” which includes components without IDs and auto-assigns an ID when you select one. For example, to drive visibility from a Yes/No question, either set an ID on that question so it appears in the normal list, or enable “Show all” and select it to auto-assign an ID."
				},
				"visibleIfAdvanced": {
					"name": "Switch to Advanced Visible If...",
					"description": "Switch to the Advanced Visible If... view. This allows advanced expressions to be created that the normal view doesn't support."
				},

				"repeatable": {
					"name": "Repeatable",
					"description": "Determines if the section is repeatable. If marked repeatable, you can add a Link Action to clone the item."
				},
				"repeatableIndex": {
					"name": "Repeatable Index",
					"description": "The index of the repeatable section."
				},
				"repeatableRetainValues": {
					"name": "Repeatable Retain Values",
					"description": "By default, all items values are reset when you repeat. By checking this option you can retain values the user entered. This is a good option to do comparison scenarios."
				},
				"repeatableInitialCount": {
					"name": "Repeatable Initial Count",
					"description": "The number of repeatable sections to initially display when the activity starts."
				},
				"repeatableMaxCount": {
					"name": "Repeatable Max Count",
					"description": "The maximum number of repeatable sections to display."
				},
				"ignoreCompletion": {
					"name": "Ignore Completion",
					"description": "The completion status of all items in the checklist are tracked at each level in the hierarchy. Setting this will ignore completion at the Section level."
				},
				"hideStatus": {
					"name": "Hide Status",
					"description": "The completion status of all items in the checklist are tracked at each level in the hierarchy. Setting this will track the status, but will hide the visual indication of the status at the Section level."
				},

				"media": {
					"name": "Media",
					"description": {
						"description": "Upload a background image for the Section. You can upload one from your local machine, reference an external URL, or reference on that you have already uploaded to the AmbiFi Drive.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},

				"viewType": {
					"name": "View Type",
					"description": "Allows you to choose the default procedure view or fullscreen view to present items. This property can be inherited from Lists, Sections or Items."
				},
				"mediaFullscreenControlVisibility": {
					"name": "Media Fullscreen Control",
					"description": "Controls whether the learner-facing media fullscreen/expand button is shown for primary image and video content. This is an inherited property."
				},
				"mediaResizeToggleVisibility": {
					"name": "Media Resize Toggle",
					"description": "Controls whether the learner-facing contain/cover media resize toggle is shown for primary image and video content. This is an inherited property."
				},
				"mediaReplayControlVisibility": {
					"name": "Media Replay Control",
					"description": "Controls whether the learner-facing media replay button is shown for replayable media. Currently this applies to Ken Burns image animations. This is an inherited property."
				},
				"itemHeight": {
					"name": "Item Height [%]",
					"description": "Controls the default vertical space used by descendant items. This is an inherited property."
				},
				"videoMute": {
					"name": "Mute Video",
					"description": "Controls whether primary item videos start muted. This is an inherited property."
				},
				"videoLoop": {
					"name": "Loop Video",
					"description": "Controls whether primary item videos loop when they finish. This is an inherited property."
				},
				"videoAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Controls the default aspect ratio for primary item videos. This is an inherited property."
				},
				"videoMaximumHeight": {
					"name": "Maximum Height [% of device height]",
					"description": "Controls the default maximum height for primary item videos. This is an inherited property."
				},
				"videoShowInBackground": {
					"name": "Show Video in Background",
					"description": "Controls whether primary item videos render in the background of descendant cards. This is an inherited property."
				},
				"videoFitAvailableSpace": {
					"name": "Fit Video to Available Space",
					"description": "Controls whether foreground fullscreen videos fill the available item area instead of sizing from the configured Video Aspect Ratio. This is an inherited property."
				},
				"videoResizeMode": {
					"name": "Video Resize Mode",
					"description": "Controls how primary item videos scale. This is an inherited property."
				},
				"videoOverlayColor": {
					"name": "Video Overlay Color",
					"description": "Controls the default overlay applied to primary item videos. This is an inherited property."
				},
				"videoOverlayColorCustom": {
					"name": "Video Overlay Color (Custom)",
					"description": "Controls the custom overlay color applied when Video Overlay Color is set to Custom. This is an inherited property."
				},
				"videoBackgroundColor": {
					"name": "Video Background Color",
					"description": "Controls the background color shown behind primary item videos when the video does not fully fill its frame. Leave blank or use transparent for no letterbox color. This is an inherited property."
				},
				"imageAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Controls the default aspect ratio for primary item images. This is an inherited property."
				},
				"imageAspectRatioCustom": {
					"name": "Custom Image Aspect Ratio",
					"description": "Controls the custom aspect ratio used when Image Aspect Ratio is set to Custom. Use x:y format, for example 5:1. This is an inherited property."
				},
				"imageShowInBackground": {
					"name": "Show Image in Background",
					"description": "Controls whether primary item images render in the background of descendant cards. This is an inherited property."
				},
				"imageFitAvailableSpace": {
					"name": "Fit Image to Available Space",
					"description": "Controls whether foreground fullscreen images fill the available item area instead of sizing from the configured Image Aspect Ratio. This is an inherited property."
				},
				"imageResizeMode": {
					"name": "Image Resize Mode",
					"description": "Controls how primary item images scale. This is an inherited property."
				},
				"imageOverlayColor": {
					"name": "Image Overlay Color",
					"description": "Controls the default overlay applied to primary item images. This is an inherited property."
				},
				"imageOverlayColorCustom": {
					"name": "Image Overlay Color (Custom)",
					"description": "Controls the custom overlay color applied when Image Overlay Color is set to Custom. This is an inherited property."
				},
				"imageMaximumHeight": {
					"name": "Image Maximum Height [% of device height]",
					"description": "Controls the default maximum height for primary item images. This is an inherited property."
				},
				"fullscreenTransition": {
					"name": "Fullscreen Transition",
					"description": "Controls the default transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionIn": {
					"name": "Fullscreen Transition In",
					"description": "Overrides the incoming transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionOut": {
					"name": "Fullscreen Transition Out",
					"description": "Overrides the outgoing transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionDelay": {
					"name": "Fullscreen Transition Delay [ms]",
					"description": "Adds an optional delay in milliseconds before the fullscreen game-style transition begins. This is an inherited property."
				},

				"fontColor": {
					"name": "Font Color",
					"description": "Select a font color for the Section title."
				},
				"iconColor": {
					"name": "Icon Color",
					"description": "Select an icon color for the Section."
				},
				"backgroundColor": {
					"name": "Background Color",
					"description": "Select a background color for the Section title. This will change the color of the header for the Section."
				},
				"borderColor": {
					"name": "Border Color",
					"description": "Select a border color for the Section title."
				},

				"stylesCss": {
					"name": "Styles",
					"description": {
						"description": "Add CSS in the form of a JSON object to set style information on specific items in the outline you are creating for an activity. For example, you can set the font information for all items or change the background color of each section header. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"classes": {
					"name": "Classes",
					"description": {
						"description": "Reference classes you create in a stylesheet. For example you can create a class .warning-box and then reference it from any item. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},

				// Print Properties
				"keepTogether": {
					"name": "Keep Together",
					"description": "Keep Together attempts to keep the List and all children on the same page."

				},
				"breakBefore": {
					"name": "Break Before",
					"description": "Breaks the page before this List."
				},
				"breakBeforeHeight": {
					"name": "Break Before Height",
					"description": "Creates an area with the height specified before the break."
				},
				"breakAfter": {
					"name": "Break After",
					"description": "Breaks the page after the List."
				},
				"breakAfterHeight": {
					"name": "Break After Height",
					"description": "Creates an area with the height after the break."

				},
				"customProperties": {
					"name": "Custom Properties (JSON Format)",
					"description": "You can supply custom properties in JSON format that get merged in with the content model. This allows you to extend the base content model for this List."
				},

				"relatedItems": {
					"name": "Related Items",
					"description": "Associate any number of related items with a List, Section or Item. If you associated them with a List or Section then the related item will appear for every item in those containers. Related items will appear in a side panel on the right. This allows an author to add some links whenever a user navigates through an activity and provides some extra context and knowledge."
				},

				"filterTags": {
					"name": "Filter Tags",
					"description": "**Filter Tags** is a feature that allows you to filter your activity when it is launched. Enter tags such as Beginner, or Advanced. When you tag something you are saying you want the option to hide or show the Section when the activity runs. Sections that are not tagged will always show, and many of your Sections would not be tagged. But if you have a specific Section you want to display like content to show if you are a beginner, then tag that Beginner."

				},
				"groupNames": {
					"name": "Group Names",
					"description": "**Group Names** allow you to group a number of Lists. This can be used with scripting to apply operations on a number of items."

				},

				"suppressAudio": {
					"name": "Don't Speak Narration",
					"description": "Mira will not read audio in this Section."
				},
				"suppressCompletionConfirmation": {
					"name": "Don't Speak Completion Confirmation",
					"description": "Normally Mira speaks when the Section is completed. This suppresses that."
				},
				"suppressPrint": {
					"name": "Don't Print",
					"description": "Excludes the Section when the checklist is printed."
				},
				"authorProperties": {
					"name": "Author Properties",
					"description": "These are advanced properties that can be set at different levels in the authoring hierarchy."
				},
				"itemButtonOkLabel": {
					"name": "Button Label",
					"description": "Change the label of the OK buttton. The OK button is displayed on a Check Item if you select the Label Only option for the Check Item. It also appears on other item types to move on after accepting a value. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemButtonBackLabel": {
					"name": "Back Button Label",
					"description": "Change the label of the Back button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use when Back Button Visibility resolves to Visible and a previous visible item exists."
				},
				"itemButtonNotApplicableLabel": {
					"name": "N/A Button Label",
					"description": "Change the label of the N/A button. This is an inherited property. You can define it at any level in the outline so child items use the same label when N/A Button Visibility resolves to Visible."
				},
				"itemButtonOkVisibility": {
					"name": "Visibility",
					"description": "Change the visibility of the OK button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) this visibility."
				},
				"itemButtonBackVisibility": {
					"name": "Back Button Visibility",
					"description": "Controls whether the Back button can appear for item OK footers. This is an inherited property. When set to Visible, the player will show Back when a previous visible item exists."
				},
				"itemButtonNotApplicableVisibility": {
					"name": "N/A Button Visibility",
					"description": "Controls whether the N/A button can appear in the item footer. This is an inherited property. When set to Visible, the player lets the user mark the current item as not applicable without entering a value."
				},
				"itemButtonOkPendingBehavior": {
					"name": "Pending Behavior",
					"description": "Controls how the OK button behaves before an item is ready to submit. Choose between keeping it visible but disabled, or hiding it until the item is ready."
				},
				"fullscreenActionVariant": {
					"name": "Fullscreen Variant",
					"description": "In fullscreen modes, choose whether items use the classic footer bar or the modern floating action variant. This is an inherited property."
				},
				"fullscreenActionPlacement": {
					"name": "Fullscreen Placement",
					"description": "When a fullscreen action variant is active, choose whether the fullscreen actions stay pinned as an overlay or stay pinned below the content area. This is an inherited property."
				},
				"fullscreenActionFlowWhenScrollable": {
					"name": "Flow With Content When Scrollable",
					"description": "When enabled, fullscreen actions use the selected pinned placement while the content fits on screen, but move to the end of the content once the content needs to scroll. This is an inherited property."
				},
				"fullscreenSwipeNavigation": {
					"name": "Fullscreen Swipe Navigation",
					"description": "Controls whether fullscreen label-only screens can use swipe up and swipe down for navigation when the screen is not scrollable and does not have blocking animation behavior. This is an inherited property."
				},
				"fullscreenSwipeSound": {
					"name": "Fullscreen Swipe Sound",
					"description": "Controls whether fullscreen swipe navigation plays the whoosh sound effect when a swipe navigation gesture succeeds. Auto disables the sound in Vertical Fullscreen View (TikTok Style) and enables it in other fullscreen vertical views. This is an inherited property."
				},
				"fullscreenLabelHideControl": {
					"name": "Fullscreen Text Hide Control",
					"description": "Controls whether users can hide label text on fullscreen label-only screens with background image or video. Auto allows hiding only when the item text is bottom-aligned with justifyContent: flex-end in Vertical View / Fullscreen, Vertical Fullscreen View (TikTok Style), or Fullscreen View (Game Style). This is an inherited property."
				},
				"fullscreenActionNavAlignment": {
					"name": "Fullscreen Nav Alignment",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary navigation cluster stays left-aligned or centered within the available footer lane while utility controls remain on the right. This is an inherited property."
				},
				"fullscreenActionNavOrder": {
					"name": "Fullscreen Nav Order",
					"description": "When fullscreen navigation shows both the primary action and Back, choose whether the primary action appears first or Back appears first. This is an inherited property."
				},
				"fullscreenActionStyle": {
					"name": "Fullscreen Floating Style",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary action is emphasized with a filled color or kept minimal on the shared surface. This is an inherited property."
				},
				"fullscreenActionPrimaryColor": {
					"name": "Floating Primary Color",
					"description": "Set the fill color used by the emphasized primary fullscreen floating action, such as Next. This is an inherited property."
				},
				"fullscreenActionSurfaceColor": {
					"name": "Floating Surface Color",
					"description": "Set the shared surface color used by fullscreen floating action capsules such as the primary navigation cluster and More button. This is an inherited property."
				},
				"fullscreenActionToolBackgroundColor": {
					"name": "Tool Background Color",
					"description": "Set the background color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to reuse the floating surface color. This is an inherited property."
				},
				"fullscreenActionToolForegroundColor": {
					"name": "Tool Foreground Color",
					"description": "Set the text and icon color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to auto-contrast against the tool background color. This is an inherited property."
				},
				"itemCommentsLabel": {
					"name": "More Button Label",
					"description": "Change the label of the Comments buttton. The Comments button is displayed on an Item if there are comments added from the author and the Comments Visibility is set to TRUE. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemCommentsIcon": {
					"name": "More Button Icon",
					"description": "Use a Font Awesome icon name for the More button. This is an inherited property."
				},
				"itemCommentsBackgroundColor": {
					"name": "More Button Background Color",
					"description": "Set the background color used by the More button. Leave blank to use the smart default blue fill derived from the fullscreen primary color. This is an inherited property."
				},
				"itemCommentsForegroundColor": {
					"name": "More Button Foreground Color",
					"description": "Set the text and icon color used by the More button. Leave blank to auto-contrast against the More button background color. This is an inherited property."
				},
				"itemRelatedItemsLabel": {
					"name": "Related Button Label",
					"description": "Change the label of the Related Items buttton. The Related Items button is displayed on an Item if you associated Related Items. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemRelatedItemsIcon": {
					"name": "Related Button Icon",
					"description": "Use a Font Awesome icon name for the Related button. This is an inherited property."
				},
				"itemRelatedItemsBackgroundColor": {
					"name": "Related Button Background Color",
					"description": "Set the background color used by the Related button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemRelatedItemsForegroundColor": {
					"name": "Related Button Foreground Color",
					"description": "Set the text and icon color used by the Related button. Leave blank to auto-contrast against the Related button background color. This is an inherited property."
				},
				"itemAttachmentsLabel": {
					"name": "Attachments Button Label",
					"description": "Change the label of the Attachments button. Leave blank to show no label by default. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemAttachmentsIcon": {
					"name": "Attachments Button Icon",
					"description": "Use a Font Awesome icon name for the Attachments button. This is an inherited property."
				},
				"itemAttachmentsBackgroundColor": {
					"name": "Attachments Button Background Color",
					"description": "Set the background color used by the Attachments button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemAttachmentsForegroundColor": {
					"name": "Attachments Button Foreground Color",
					"description": "Set the text and icon color used by the Attachments button. Leave blank to auto-contrast against the Attachments button background color. This is an inherited property."
				},
				"defaultColumnWidth": {
					"name": "Default Column Width",
					"description": "Sets the default column width of the section. This is an inherited proeprty. You can set this property at any level of the outline (Activity, List, Section) and all the children in the container can inherit or override."
				},
				"defaultFocusedMode": {
					"name": "Default Focused Mode",
					"description": "Focused mode highlights the current item and presents all other items a disabled look so the user can focus on the currently selected item. This is an inherited proeprty. You can set this property at any level of the outline (Activity, List, Section) and all the children in the container can inherit or override."
				},
				"defaultAlwaysMoveForward": {
					"name": "Default Always Move Forward",
					"description": "Controls whether navigation automatically continues when the next target is outside an incomplete section. When Off, the player asks whether to return to an unchecked item in that section or move forward. User Preference uses the player's Always Move Forward setting, which defaults On. Lists and sections can inherit or override this value."
				},
				"userNotesVisibility": {
					"name": "User Notes Visibility",
					"description": "Any item can allow a user to attach their own notes. These notes become part of the history of the activity and can be viewed from the Status panel in AmbiFi Cloud. This allows you to set what items you would allow a user to capture notes. This is an inherited propertty. If you set it visible here, and you set all other items to inherit this, then every item will allow the user to add notes."
				}
			}
		}
	},
	"item": {
		"menu": "Add Item",
		"title": "Item",
		"description": "An Item is the primary content that you are creating. There are many different Item Types. Examples are Check Item, Text Input, Picker, Yes / No. All Item Types have the same set of base properties, and then specific properties unique to the Item Type.",
		"properties": {
			"properties": {
				// Common
				"type": {
					"name": "Type",
					"description": {
						"description": "The type of item. There are many types of items you can add to the checklist. e.g. Check Item, Text Input, Yes / No, Picker.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Item Types and Definitions",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/item-types/index.html"
							}
						]

					}
				},
				"aiAssistantSummarize": {
					"name": "AI Assistant",
					"description": "The AI Assistant allows you to quickly summarize content in a variety of ways. The **Prompt for Description** is more generic and allows you to type any prompt or question in the above input (e.g. Label 1) and will generate a response that you can decide to paste into the appropriate input (e.g. Label 1)."
				},
				"labelOnly": {
					"name": "Label Only",
					"description": "Allows you to hide the checkbox for the Check Item. In its place it puts an OK button to acknowledge the item. This is useful when content is more informational than a typical item that you would check off."
				},
				"labelOnlyBackgroundColor": {
					"name": "Label Only Background Color",
					"description": "The background color when an item is designated a Label Only."
				},
				"label1": {
					"name": "Label 1",
					"description": {
						"description": "**Label 1** content. In a challenge/response checklist this is typically a challenge. e.g. Gear. For labels you have the option of using a rich text editor or a more advanced Markdown editor. Markdown is a standard for creating wich text with simple characters. Note: Although most Markdown is supported, especially the basics of bold, italic and bullets, there are many flavors of Markdown and every capability is not supported. Native apps are typically limited in their support for Markdown.",
						"learnMoreLinks": [
							{
								"title": "Markdown - Basic Syntax",
								"url": "https://www.markdownguide.org/basic-syntax/"
							}
						]

					}
				},
				"label1NarrationOverride": {
					"name": "Label 1 Narration Override",
					"description": {
						"description": "Mira will read this content instead of the content in the **Label 1** property. Use **Paste Label 1** to paste the current Label 1 as a starting point.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Enhancing Pronunciation",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/tts-phonetics/index.html"
							}
						]
					}
				},
				"label1SsmlOverride": {
					"name": "Label 1 SSML Override",
					"description": {
						"description": "The generated content will use this content instead of the Label 1 content. When you generate audio files, Speech Synthesis Markup Language (SSML) is supported. SSML allows advanced control over the audio narration being created. *Note: This only works when you generate audio narration.*",
						"learnMoreLinks": [
							{
								"title": "Generating Speech from SSML Documents",
								"url": "https://docs.aws.amazon.com/polly/latest/dg/ssml.html"
							}
						]
					}
				},
				"label1PrintOverride": {
					"name": "Label 1 Print Override",
					"description": "When you print a checklist, this content will display instead of the content in the **Label 1** property. Use **Paste Label 1** to paste the current Label 1 as a starting point."
				},
				"label1Audio": {
					"name": "Label 1 Audio",
					"description": {
						"description": "Allows you to replace the default device text-to-speech with a recorded audio file. You can upload an MP3, reference an external URL, select and exising one from the AmbiFi Drive or generate audio from the Amazon Polly service.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"suppressLabel1Audio": {
					"name": "Don't Speak Label 1",
					"description": "Mira will not narrate Label 1."
				},
				"speakLabel1ButDontRepeat": {
					"name": "Speak Label 1, But Don't Repeat",
					"description": "Mira will speak Label 1 the first time the item is narrated in the player, but will not repeat Label 1 on later narrations of the same item."
				},
				"label2": {
					"name": "Label 2",
					"description": {
						"description": "**Label 2** content. In a challenge/response checklist this is typically a response. e.g. Down, Three Green. For labels you have the option of using a rich text editor or a more advanced Markdown editor. Markdown is a standard for creating wich text with simple characters. Note: Although most Markdown is supported, especially the basics of bold, italic and bullets, there are many flavors of Markdown and every capability is not supported. Native apps are typically limited in their support for Markdown.",
						"learnMoreLinks": [
							{
								"title": "Markdown - Basic Syntax",
								"url": "https://www.markdownguide.org/basic-syntax/"
							}
						]

					}
				},
				"label2NarrationOverride": {
					"name": "Label 2 Narration Override",
					"description": {
						"description": "Mira will read this content instead of the content in the **Label 2** property. Use **Paste Label 2** to paste the current Label 2 as a starting point.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Enhancing Pronunciation",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/tts-phonetics/index.html"
							}
						]
					}
				},
				"label2SsmlOverride": {
					"name": "Label 2 SSML Override",
					"description": {
						"description": "The generated content will use this content instead of the Label 2 content. When you generate audio files, Speech Synthesis Markup Language (SSML) is supported. SSML allows advanced control over the audio narration being created. *Note: This only works when you generate audio narration.*",
						"learnMoreLinks": [
							{
								"title": "Generating Speech from SSML Documents",
								"url": "https://docs.aws.amazon.com/polly/latest/dg/ssml.html"
							}
						]
					}
				},
				"label2PrintOverride": {
					"name": "Label 2 Print Override",
					"description": "When you print a checklist, this content will display instead of the content in the **Label 2** property. Use **Paste Label 2** to paste the current Label 2 as a starting point."
				},
				"label2Audio": {
					"name": "Label 2 Audio",
					"description": {
						"description": "Allows you to replace the default device text-to-speech with a recorded audio file. You can upload an MP3, reference an external URL, select and exising one from the AmbiFi Drive or generate audio from the Amazon Polly service.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"suppressLabel2Audio": {
					"name": "Don't Speak Label 2",
					"description": "Mira will not narrate Label 2."
				},
				"speakLabel2ButDontRepeat": {
					"name": "Speak Label 2, But Don't Repeat",
					"description": "Mira will speak Label 2 the first time the item is narrated in the player, but will not repeat Label 2 on later narrations of the same item."
				},

				"id": {
					"name": "ID (An ID is required for any Item you want to target with Visible If... or any Item you want to link to)",
					"description": {
						"description": "Assigning an ID at the Item level allows you to target the Item for Visible If... or linking. If using more advanced capabilities like a **Value Trigger** you also would use an ID to allow scripts to address it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Visible If...",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/visible-if/index.html"
							},
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251"
							},
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},

				"visible": {
					"name": "Visible",
					"description": "Enables you to determine if you want the Item initially visible or not. You can use this in conjunction with scripting to make the Item appear dynamically."
				},
				"visibleIf": {
					"name": "Visible If...",
					"description": {
						"description": "Visible If lets you show or hide this item based on a true/false rule. Pick another component in the dropdown and build a condition: if the rule is true, this item shows; if false, it hides. Components normally need an ID to be referenced—set one on the target component first. If you don’t see it, turn on “Show all” to include every node; selecting one without an ID will auto-assign it. Use the sort (Outline/Alphabetical) and “Show IDs” toggles to navigate large trees, or switch to Advanced to edit the full Boolean expression directly (AND/OR groups, comparisons).",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Visible If...",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/visible-if/index.html"
							}
						]
					}
				},
				"visibleIfComponentWithId": {
					"name": "...the following component with ID:",
					"description": "To target another component you can either use the normal list, which shows components that already have an ID you set manually, or turn on “Show all,” which includes components without IDs and auto-assigns an ID when you select one. For example, to drive visibility from a Yes/No question, either set an ID on that question so it appears in the normal list, or enable “Show all” and select it to auto-assign an ID."
				},
				"visibleIfAdvanced": {
					"name": "Switch to Advanced Visible If...",
					"description": "Switch to the Advanced Visible If... view. This allows advanced expressions to be created that the normal view doesn't support."
				},

				"repeatable": {
					"name": "Repeatable",
					"description": "Determines if the item is repeatable. If marked repeatable, you can add a Link Action to clone the item."
				},
				"repeatableIndex": {
					"name": "Repeatable Index",
					"description": "The index of the repeatable item."
				},
				"repeatableRetainValues": {
					"name": "Repeatable Retain Values",
					"description": "By default, all items values are reset when you repeat. By checking this option you can retain values the user entered. This is a good option to do comparison scenarios."
				},
				"repeatableInitialCount": {
					"name": "Repeatable Initial Count",
					"description": "The number of repeatable items to initially display when the activity starts."
				},
				"repeatableMaxCount": {
					"name": "Repeatable Max Count",
					"description": "The maximum number of repeatable items to display."
				},
				"ignoreCompletion": {
					"name": "Ignore Completion",
					"description": "The completion status of all items in the checklist are tracked at each level in the hierarchy. Setting this will ignore completion for this Item."
				},

				"media": {
					"name": "Media",
					"description": {
						"description": "Upload media assets for the item. You can upload one from your local machine, reference an external URL, or reference on that you have already uploaded to the AmbiFi Drive.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},

				"comments": {
					"name": "Comments",
					"description": "Allows you to add HTML comments to the item. An icon will appear on the item that denotes it has comments. It will slide up a full screen webview of the content. There is an HTML rich text editor to create the content."
				},
				"commentsUrl": {
					"name": "Comments URL",
					"description": "This will show the specified URL in the comments view instead of the authored comments."
				},
				"commentsUrlOpenMode": {
					"name": "Comments URL Open Mode",
					"description": "Controls whether a Comments URL opens in a new tab or inside the comments modal. Auto opens image, video, and PDF URLs in the comments modal and leaves other URLs in a new tab."
				},
				"commentsNarrationOverride": {
					"name": "Comments Narration Override",
					"description": {
						"description": "Mira will read this content instead of the content in the **Comments**",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Enhancing Pronunciation",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/tts-phonetics/index.html"
							}
						]
					}
				},
				"commentsPrintOverride": {
					"name": "Comments Print Override",
					"description": "When you print a checklist, this content will display instead of the content in the **Comments**."
				},
				// "suppressPrintComments": {
				// 	"name": "Don't Print Comments",
				// 	"description": "Excludes the content when the checklist is printed."
				// },
				"commentsAudio": {
					"name": "Select an option:",
					"description": {
						"description": "Allows you to replace the default device text-to-speech with a recorded audio file. You can upload an MP3, reference an external URL, select and exising one from the AmbiFi Drive or generate audio from the Amazon Polly service.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Adding Media Assets (AmbiFi Drive Resources)",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/media/index.html"
							}
						]
					}
				},
				"commentsTemplate": {
					"name": "Comments Template",
					"description": "A relative path to a handlebars HTML template."
				},
				"commentsDataPath": {
					"name": "Comments Data Path",
					"description": "A path in the JSON file to select the branch of content to target."
				},
				"userNotesVisibility": {
					"name": "User Notes Visibility",
					"description": "Any item can allow a user to attach their own notes. These notes become part of the history of the activity and can be viewed from the Status panel in AmbiFi Cloud. This allows you to set what items you would allow a user to capture notes. This is an inherited propertty. If you set it visible here, and you set all other items to inherit this, then every item will allow the user to add notes."
				},
				"commentsInline": {
					"name": "Inline Comments (Experimental)",
					"description": "This will inline the HTML comments in your checkbox item. Only a small subset of HTML is supported. Try to use sparingly and keep the content relatively small."
				},

				"viewType": {
					"name": "View Type",
					"description": "Allows you to choose the default procedure view or fullscreen view to present items. This property can be inherited from Lists, Sections or Items."
				},
				"fullscreenTransition": {
					"name": "Fullscreen Transition",
					"description": "Controls the default transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionIn": {
					"name": "Fullscreen Transition In",
					"description": "Overrides the incoming transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionOut": {
					"name": "Fullscreen Transition Out",
					"description": "Overrides the outgoing transition animation for fullscreen game-style cards. This is an inherited property."
				},
				"fullscreenTransitionDelay": {
					"name": "Fullscreen Transition Delay [ms]",
					"description": "Adds an optional delay in milliseconds before the fullscreen game-style transition begins. This is an inherited property."
				},
				"required": {
					"name": "Required",
					"description": "A **Required** item must have a value."
				},
				"requiredMessage": {
					"name": "Required Message",
					"description": "The message to display if the item is required and does not have a value."
				},
				"mandatory": {
					"name": "Mandatory",
					"description": "A **Mandatory** item must be completed before you can move on. It is mostly used for a series of Checkbox Items where you want to for a linear flow through the items. All other items in the List are disabled until it is completed. Note: It only disables items in the current List. You can navigate to other Lists."
				},
				"valueSticky": {
					"name": "Value Sticky",
					"description": "Make the value sticky between sessions."
				},
				"suppressItemValueAudio": {
					"name": "Don't Speak Item Value",
					"description": "For Item Types that have a value, this suppresses Mira narrating the audio value when a selection is made."
				},

				"videoMute": {
					"name": "Mute Video",
					"description": "Mutes the video when it plays. This allows you to have the narration audio to play while the video is playing."
				},
				"videoLoop": {
					"name": "Loop Video",
					"description": "Loop the video after it gets to the end."
				},
				"videoAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Choose a an aspect ratio for the video."
				},
				"videoAspectRatioCustom": {
					"name": "Custom Aspect Ratio",
					"description": "Choose a custom video aspect ratio."
				},
				"videoMaximumHeight": {
					"name": "Maximum Height [% of device height]",
					"description": "Choose a maximum height for the video."
				},
				"videoShowInBackground": {
					"name": "Show Video in Background",
					"description": "Displays the video in the background of the card. Use Video Resize Mode to influence how the video scales. Use Video Overlay Color to apply an overlay so that text is easier to read."
				},
				"videoFitAvailableSpace": {
					"name": "Fit Video to Available Space",
					"description": "For foreground videos in fullscreen game-style view, fills the available item area. Leave off to size from Video Aspect Ratio."
				},
				"mediaFullscreenControlVisibility": {
					"name": "Media Fullscreen Control",
					"description": "Controls whether the learner-facing media fullscreen/expand button is shown for the item's primary image or video. This is an inherited property."
				},
				"mediaResizeToggleVisibility": {
					"name": "Media Resize Toggle",
					"description": "Controls whether the learner-facing contain/cover media resize toggle is shown for the item's primary image or video. This is an inherited property."
				},
				"mediaReplayControlVisibility": {
					"name": "Media Replay Control",
					"description": "Controls whether the learner-facing media replay button is shown for replayable item media. Currently this applies to Ken Burns image animations. This is an inherited property."
				},
				"videoResizeMode": {
					"name": "Video Resize Mode",
					// "description": "Video Resize Mode influences how the video scales. Valid values are contain, cover, stretch.\n\ncontain: Scale the video uniformly (maintain the video's aspect ratio) so that both dimensions (width and height) of the video will be equal to or less than the corresponding dimension of the view (minus padding).\n\ncover: Scale the video uniformly(maintain the video's aspect ratio) so that both dimensions (width and height) of the video will be equal to or larger than the corresponding dimension of the view (minus padding).\n\nstretch: Scale width and height independently, This may change the aspect ratio of the src."
					"description": "Video Resize Mode influences how the video scales. Valid values are contain and cover.\n\ncontain: Scale the video uniformly (maintain the video's aspect ratio) so that both dimensions (width and height) of the video will be equal to or less than the corresponding dimension of the view (minus padding).\n\ncover: Scale the video uniformly(maintain the video's aspect ratio) so that both dimensions (width and height) of the video will be equal to or larger than the corresponding dimension of the view (minus padding)."
				},
				"videoOverlayColor": {
					"name": "Video Overlay Color",
					"description": "Video Overlay Color adds a layer on top of the video so that text is easier to read. This layer typically has an opacity value which determines how opaque the overlay is. You can set the value to 'Transparent' if you don't want an overlay."
				},
				"videoOverlayColorCustom": {
					"name": "Video Overlay Color (Custom)",
					"description": "Add a custom color using format rgba(255,255,255,0.7) or #ffffffcc. You can also enter a value of transparent."
				},
				"videoBackgroundColor": {
					"name": "Video Background Color",
					"description": "Controls the color shown behind the video when the video does not fully fill its frame. Leave blank or use transparent for no letterbox color."
				},
				"videoTextTracks": {
					"name": "Video Text Tracks",
					"description": "Add text tracks for a specific language to the video."
				},
				"videoInlineViewer": {
					"name": "Inline Video Viewer",
					"description": "Controls which viewer style is preferred for inline video. AmbiFi Viewer keeps the player controls; Browser/Web Viewer lets compatible platforms use the browser-style viewer."
				},
				"videoModalViewer": {
					"name": "Fullscreen Video Viewer",
					"description": "Controls which viewer style is preferred when the video opens fullscreen. AmbiFi Viewer keeps the consistent modal; Browser/Web Viewer uses the platform/browser viewer when supported."
				},
				"videoStartTime": {
					"name": "Start Time",
					"description": "Optional time where playback should begin. Use seconds or mm:ss / hh:mm:ss."
				},
				"videoEndTime": {
					"name": "End Time",
					"description": "Optional time where playback should stop. Use seconds or mm:ss / hh:mm:ss."
				},
				"videoLoopSegment": {
					"name": "Loop Segment",
					"description": "Loops between the start and end time instead of continuing to the end of the video."
				},
				"videoResumeBehavior": {
					"name": "Resume Behavior",
					"description": "Controls whether returning to the item restarts the video or resumes where the learner left off."
				},
				"videoCompletionBehavior": {
					"name": "Completion Behavior",
					"description": "Controls what happens when the video reaches its authored end time or natural end."
				},
				"videoActionVisibility": {
					"name": "Video Actions",
					"description": "Controls whether optional fullscreen video actions such as native preview/share controls are visible. Close remains available."
				},
				"videoCaption": {
					"name": "Video Caption",
					"description": "Optional caption shown with the fullscreen video preview."
				},
				"imageAspectRatio": {
					"name": "Aspect Ratio",
					"description": "Choose an aspect ratio for the image."
				},
				"imageAspectRatioCustom": {
					"name": "Custom Image Aspect Ratio",
					"description": "Choose a custom image aspect ratio in x:y format, for example 5:1."
				},
				"imageShowInBackground": {
					"name": "Show Image in Background",
					"description": "Displays the image in the background of the card. Use Image Resize Mode to influence how the image scales. Use Image Overlay Color to apply an overlay so that text is easier to read."
				},
				"imageFitAvailableSpace": {
					"name": "Fit Image to Available Space",
					"description": "For foreground images in fullscreen game-style view, fills the available item area. Leave off to size from Image Aspect Ratio, which defaults to 16:9."
				},
				"imageResizeMode": {
					"name": "Image Resize Mode",
					// "description": "Image Resize Mode influences how the image scales. Valid values are contain, cover, stretch, repeat, center.\n\nDetermines how to resize the image when the frame doesn't match the raw image dimensions.\n\ncontain: Scale the image uniformly (maintain the image's aspect ratio) so that both dimensions (width and height) of the image will be equal to or less than the corresponding dimension of the view (minus padding).\n\ncover: Scale the image uniformly(maintain the image's aspect ratio) so that both dimensions (width and height) of the image will be equal to or larger than the corresponding dimension of the view (minus padding).\n\nstretch: Scale width and height independently, This may change the aspect ratio of the src.\n\nrepeat: Repeat the image to cover the frame of the view.The image will keep its size and aspect ratio, unless it is larger than the view, in which case it will be scaled down uniformly so that it is contained in the view.\n\ncenter: Center the image in the view along both dimensions.If the image is larger than the view, scale it down uniformly so that it is contained in the view."
					"description": "Image Resize Mode influences how the image scales. Valid values are contain and cover.\n\nDetermines how to resize the image when the frame doesn't match the raw image dimensions.\n\ncontain: Scale the image uniformly (maintain the image's aspect ratio) so that both dimensions (width and height) of the image will be equal to or less than the corresponding dimension of the view (minus padding).\n\ncover: Scale the image uniformly(maintain the image's aspect ratio) so that both dimensions (width and height) of the image will be equal to or larger than the corresponding dimension of the view (minus padding)."
				},
				"imageOverlayColor": {
					"name": "Image Overlay Color",
					"description": "Image Overlay Color adds a layer on top of the image so that text is easier to read. This layer typically has an opacity value which determines how opaque the overlay is. You can set the value to 'Transparent' if you don't want an overlay."
				},
				"imageOverlayColorCustom": {
					"name": "Image Overlay Color (Custom)",
					"description": "Add a custom color using format rgba(255,255,255,0.7) or #ffffffcc. You can also enter a value of transparent."
				},
				"imageKenBurnsEffectEnabled": {
					"name": "Enable Ken Burns Effect",
					"description": "Enables a Ken Burns effect which is an animation that adds movement to an image."
				},
				"imageKenBurnsEffectDuration": {
					"name": "Ken Burns Effect Duration [seconds]",
					"description": "The duration of the Ken Burns effect animation. The value is in seconds."
				},
				"imageKenBurnsEffectStartScaleX": {
					"name": "Ken Burns Effect Start Scale X",
					"description": "The starting scale factor in the x direction. The default is a factor of 1."
				},
				"imageKenBurnsEffectStartScaleY": {
					"name": "Ken Burns Effect Start Scale Y",
					"description": "The starting scale factor in the y direction. The default is a factor of 1."
				},
				"imageKenBurnsEffectEndScaleX": {
					"name": "Ken Burns Effect End Scale X",
					"description": "The ending scale factor in the x direction. The default is a factor of 1.3 (scale the image to 130%)."
				},
				"imageKenBurnsEffectEndScaleY": {
					"name": "Ken Burns Effect End Scale Y",
					"description": "The ending scale factor in the y direction. The default is a factor of 1.3 (scale the image to 130%)."
				},
				"imageInlineViewer": {
					"name": "Inline Image Viewer",
					"description": "Controls which viewer style is preferred for inline images. AmbiFi Viewer keeps the player controls; Browser/Web Viewer lets compatible platforms use the browser-style viewer."
				},
				"imageModalViewer": {
					"name": "Fullscreen Image Viewer",
					"description": "Controls which viewer style is preferred when the image opens fullscreen. AmbiFi Viewer keeps the consistent modal; Browser/Web Viewer uses the platform/browser viewer when supported."
				},
				"imageCropMode": {
					"name": "Image Crop Method",
					"description": "Choose whether to crop by focus point plus zoom, or by entering a source-image rectangle."
				},
				"imageFocalPoint": {
					"name": "Image Crop Focus",
					"description": "Controls the X/Y focus point that stays visible when an image is cover-cropped. Use 50/50 for center, 0/0 for top-left, and 100/100 for bottom-right."
				},
				"imageCropZoom": {
					"name": "Image Crop Zoom",
					"description": "Zooms into the image inside its existing frame so the crop focus can show a specific region. 100% keeps the normal image view; 200% shows roughly half the image width and height around the focus point."
				},
				"imageCropRect": {
					"name": "Image Crop Rectangle",
					"description": "Sets a crop rectangle using X, Y, Width, and Height percentages of the source image. Use a rectangle with the same aspect ratio as the image frame for an exact crop without extra visible area."
				},
				"imageModalInitialZoom": {
					"name": "Fullscreen Initial Zoom",
					"description": "Optional initial zoom level when the image opens fullscreen."
				},
				"imageActionVisibility": {
					"name": "Image Actions",
					"description": "Controls whether optional fullscreen image actions such as native preview/share controls are visible. Close remains available."
				},
				"imageCaption": {
					"name": "Image Caption",
					"description": "Optional caption shown with the fullscreen image preview."
				},
				"imageAltText": {
					"name": "Image Alt Text",
					"description": "Optional accessibility text for the image."
				},
					"imageMaximumHeight": {
						"name": "Image Maximum Height [% of device height]",
						"description": "Choose a maximum height for the image."
					},
						"pdfViewMode": {
							"name": "PDF View Mode",
							"description": "Controls whether this PDF initially opens as a single page or as a continuous all-pages document. Inherit uses the player/user default."
						},
						"pdfSinglePage": {
							"name": "Render Current Page Only",
							"description": "When enabled with PDF View Mode set to Single Page, the native AmbiFi viewer renders only the configured initial/current page. This is useful when each checklist item represents one page of a larger PDF."
						},
						"pdfInlineViewer": {
							"name": "Inline PDF Viewer",
							"description": "Controls whether the inline PDF uses the AmbiFi viewer or the browser/web PDF viewer. Inherit keeps the player default."
						},
						"pdfModalViewer": {
							"name": "Fullscreen PDF Viewer",
							"description": "Controls whether the fullscreen PDF modal uses the AmbiFi viewer or the browser/web PDF viewer. Inherit keeps the player default."
						},
						"pdfFitAvailableSpace": {
							"name": "Fit PDF to Available Space",
							"description": "Controls whether foreground fullscreen PDFs fill the available item area. The default is to fit available space."
						},
						"pdfInitialPage": {
						"name": "Initial Page",
						"description": "Optional page number to show first when this PDF opens. This also maps to the standard PDF URL page parameter."
					},
					"pdfInitialZoom": {
						"name": "Initial Zoom",
						"description": "Sets the PDF's starting zoom. Fit Page shows the whole page; Fit Width fills the available width. Numeric values such as 125% start zoomed in."
					},
					"pdfPageMode": {
						"name": "Browser Page Mode",
						"description": "Optional page mode passed to the browser/native PDF viewer when opening externally or using browser PDF fallback."
					},
					"pdfNamedDestination": {
						"name": "Named Destination",
						"description": "Optional PDF named destination to open instead of a page number when the browser/native PDF viewer supports named destinations."
					},
					"pdfSearchText": {
						"name": "Search Text",
						"description": "Optional text passed to browser/native PDF viewers that support PDF URL search parameters."
					},

					"useAsSessionName": {
					"name": "Use as Session Name",
					"description": "A Session Name (if provided) appears for each card in the Status panel. This allows you to more easily search status. Set this to mark this item to contribute to the session name. Multiple items can be set to contribute to the session name. An example of when you would use this. You could have an input called Location and another input called Room Number. If you set both of those to **Use as Session Name** then when you view status, there will be a title *Main Campus - Room 145*."
				},
				"isSearchable": {
					"name": "Is Searchable?",
					"description": "Determines if the content of the item should be searchable in the Status panel."
				},
				"calculatedDefaultValue": {
					"name": "Calculated Default Value",
					"description": "Allows you to calculate a default value based on other values within this procedure."
				},
				"addressDefaultValue": {
					"name": "Default Address",
					"description": "Optional validated address to pre-populate when a new session starts. Use the address search suggestions so AmbiFi stores the formatted address, place metadata, and coordinates."
				},

				"saveAsPrivate": { "name": "Save as private", "description": "Store text separately with restricted access in an enrolled web activity. Other item types are not supported yet." },
				// Text Input
				"textInputPlaceholder": {
					"name": "Placeholder",
					"description": "Allows you to provide a placeholder or hint text in the field to guide the user of the type of content to input."
				},
				"textInputDefaultValue": {
					"name": "Default Value",
					"description": "Allows you to set a default value for the input."
				},
				"textInputMaxLength": {
					"name": "Max Length",
					"description": "Allows you tto set a max length od characters on the text input."
				},
				"textInputControlType": {
					"name": "Input Control",
					"description": "Choose whether this item should render as a normal text field, numeric stepper, or slider. Numeric controls are supported for single-line text input items."
				},
				"numericStepperMin": {
					"name": "Minimum",
					"description": "Optional lowest value allowed by the numeric stepper or slider."
				},
				"numericStepperMax": {
					"name": "Maximum",
					"description": "Optional highest value allowed by the numeric stepper or slider."
				},
				"numericStepperStep": {
					"name": "Step",
					"description": "Amount to add or subtract when the user taps the numeric stepper controls or moves the slider."
				},
				"numericStepperPrecision": {
					"name": "Precision",
					"description": "Optional number of decimal places to display and retain."
				},
				"textInputMaskType": {
					"name": "Mask Type",
					"description": "Allows you to add a mask to the text input. Currently, a phone number or a currency field are the only supported masks."
				},
				"textInputCustomMask1": {
					"name": "Custom Mask (Web Player)",
					"description": "Apply a custom mask to the input field for the AmbiFi Web Player. Default format characters are:\n\n* 9: 0 - 9\n* a: A - Z, a- z\n* *: A- Z, a- z, 0-9\n\nExample: (999) 999-9999\nExample: 99 weeks 9 days\n\nYou can also create more advanced masks using regular expressions. You provide an array of regular expressions. This is an example of a Canadian Postal Code: [/(?!.*[DFIOQU])[A-Z]/i, /[0-9]/,  /(?!.*[DFIOQU])[A-Z]/i, \" \", /[0-9]/,  /(?!.*[DFIOQU])[A-Z]/i, /[0-9]/]"
				},
				"textInputCustomMask2": {
					"name": "Custom Mask (Mobile Player)",
					"description": {
						"description": "Apply a custom mask to the input field for the AmbiFi Mobile Player. Default format characters are:\n\nExample: ([000]) [000]-[0000]\nExample: [00] weeks [0] days",
						"learnMoreLinks": [
							{
								"title": "Mobile Player Input Mask Syntax",
								"url": "https://github.com/RedMadRobot/input-mask-ios/wiki/1.-Mask-Syntax"
							}
						]
					}
				},
				"keyboardType": {
					"name": "Keyboard Type",
					"description": {
						"description": "Determines which keyboard to open, e.g.numeric.\n\nThe following values work across platforms:\n\n* Default\n* Number Pad\n* Decimal Pad\n* Numeric\n* Email Address\n* Phone Pad\n\nThe following values work on iOS only:\n\n* ASCII Capable\n* Numbers And Punctuation\n* Url\n* Name and Phone Pad\n* Twitter\n* Web Search\n\nThe following values work on Android only:\n\n* Visible Password",
						"learnMoreLinks": [
							{
								"title": "Screenshots of Keyboard Types",
								"url": "https://lefkowitz.me/visual-guide-to-react-native-textinput-keyboardtype-options/"
							}
						]
					}
				},
				"keyboardAutoCapitalize": {
					"name": "Auto Capitalize",
					"description": "Can tell TextInput to automatically capitalize certain characters. This property is not supported by some keyboard types such as name-phone-pad.\n\n* characters: all characters.\n* words: first letter of each word.\n* sentences: first letter of each sentence (default).\n* none: don't auto capitalize anything."
				},
				"keyboardAutoCorrect": {
					"name": "Auto Correct",
					"description": "Auto-correct attempts to correct text as you type."
				},
				"keyboardReturnKeyType": {
					"name": "Return Key Type",
					"description": "Determines how the return key should look.\n\nThe following are return key type options:\n\n* Done\n* Go\n* Next\n* Search\n* Send\n\nThe following values work on iOS only:\n\n* Emergency Call\n* Google\n* Join\n* Route\n* Yahoo\n\nThe following values work on Android only:\n\n* None\n* Previous"
				},
				"keyboardReturnKeySubmitsItem": {
					"name": "Return Key Performs OK",
					"description": "When enabled, the mobile player treats an action return key such as Done/checkmark, Go, Search, Send, or Next as if the user tapped the item OK button. For Text Input Multiline, Default still keeps the normal newline behavior; choose an action return key and enable this option to submit from the keyboard."
				},

				// Yes/No
				"yesNoLinkOnSelect": {
					"name": "Link On Select",
					"description": {
						"description": "Linking allows you you to navigate to another part of the checklist or to another checklist. Turning this property on will perform the link action. The Yes Link ID and No Link ID properties is where you specifiy the ID of the item you want to link to. When linking within the checklist, you add a # sign before the ID. e.g. #postflight. For linking to work, you must also set an ID on the item you are linking to. See the ID property for details on setting an ID on items in the checklist.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"yesNoLinkAction": {
					"name": "Link Action",
					"description": {
						"description": "The action to perform when linking. The following are the supported link actions:\n\n| Name                          | Inline Command              | Description                                                                                                                                                                                                                                                               |\n|-------------------------------|-----------------------------|---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|\n| Goto                          | goto:                       | Goto an item with an ID.                                                                                                                                                                                                                                                  |\n| Goto Unchecked                | gotoUnchecked:              | Goto the first unchecked item with an ID.                                                                                                                                                                                                                                 |\n| Goto (New Session)            | newSessionAndGoto:          | This creates a new session for the checklist and then does a goto to the item.                                                                                                                                                                                            |\n| Goto (Reset Items In Range)   | resetRangeAndGoto:          | Goto an item and reset all the items in between the one you are currently on. The item you are jumping to should typically be before the item you are jumping from. An example of its usage would be to reset all the items from takeoff to landing after a touch-and-go. |\n| Goto (Check Items In Range)   | checkRangeAndGoto:          | Goto an item and check all the items in between the one you are currently on. The item you are jumping to should typically be after the item you are jumping from.                                                                                                        |\n| Goto and Return               | gotoAndReturn:              | Goto an item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                                            |\n| Goto Unchecked and Return     | gotoUncheckedAndReturn:     | Goto the first unchecked item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                           |\n| Goto and Return (New Session) | newSessionAndGotoAndReturn: | This creates a new session for the checklist and then does a goto to the item. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                      |\n| Goto and Open Birdseye View   | gotoAndOpenBirdseyeView:    | Goto an item with an ID and switch to Birdseye View.                                                                                                                                                                                                                      |\n| Reset Current Checklist       | resetCurrentChecklist       | Resets the current Checklist. This gives you a new session of the Checklist which effectively clears all items to their default state.                                                                                                                                    |\n| Reset Current List            | resetCurrentList            | Resets the current List. This clears all items to their default state in the current List.                                                                                                                                                                                |\n| Reset Current Section         | resetCurrentSection         | Resets the current Section. This clears all items to their default state in the current Section.                                                                                                                                                                          |\n| Open Comments                 | openComments                | Opens the Comments view. The Comments view allows detailed rich text content to be added for each item.                                                                                                                                                                   |\n| Open Notes                    | openNotes                   | Opens the Notes view. Each item allows user notes to be added.                                                                                                                                                                                                            |\n| Open Sketchpad                | openSketchpad               | Opens the Sketchpad view. Each item allows a sketchpad.                                                                                                                                                                                                                   |\n| External                      | external:                   | Opens and external URL. This allows you to launch content from any URL on the web. You can also utilize URL's the mobile device supports.                                                                                                                                 |",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"yesNoYesLinkId": {
					"name": "Yes Link ID",
					"description": {
						"description": "Links to the item with the ID specified when you click Yes. If linking within this checklist then prepend the ID with a #. e.g. #preflight.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251"
							},
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},
				"yesNoYesLinkAction": {
					"name": "Yes Link Action",
					"description": {
						"description": "The action to perform when linking. The following are the supported link actions:\n\n| Name                          | Inline Command              | Description                                                                                                                                                                                                                                                               |\n|-------------------------------|-----------------------------|---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|\n| Goto                          | goto:                       | Goto an item with an ID.                                                                                                                                                                                                                                                  |\n| Goto Unchecked                | gotoUnchecked:              | Goto the first unchecked item with an ID.                                                                                                                                                                                                                                 |\n| Goto (New Session)            | newSessionAndGoto:          | This creates a new session for the checklist and then does a goto to the item.                                                                                                                                                                                            |\n| Goto (Reset Items In Range)   | resetRangeAndGoto:          | Goto an item and reset all the items in between the one you are currently on. The item you are jumping to should typically be before the item you are jumping from. An example of its usage would be to reset all the items from takeoff to landing after a touch-and-go. |\n| Goto (Check Items In Range)   | checkRangeAndGoto:          | Goto an item and check all the items in between the one you are currently on. The item you are jumping to should typically be after the item you are jumping from.                                                                                                        |\n| Goto and Return               | gotoAndReturn:              | Goto an item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                                            |\n| Goto Unchecked and Return     | gotoUncheckedAndReturn:     | Goto the first unchecked item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                           |\n| Goto and Return (New Session) | newSessionAndGotoAndReturn: | This creates a new session for the checklist and then does a goto to the item. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                      |\n| Goto and Open Birdseye View   | gotoAndOpenBirdseyeView:    | Goto an item with an ID and switch to Birdseye View.                                                                                                                                                                                                                      |\n| Reset Current Checklist       | resetCurrentChecklist       | Resets the current Checklist. This gives you a new session of the Checklist which effectively clears all items to their default state.                                                                                                                                    |\n| Reset Current List            | resetCurrentList            | Resets the current List. This clears all items to their default state in the current List.                                                                                                                                                                                |\n| Reset Current Section         | resetCurrentSection         | Resets the current Section. This clears all items to their default state in the current Section.                                                                                                                                                                          |\n| Open Comments                 | openComments                | Opens the Comments view. The Comments view allows detailed rich text content to be added for each item.                                                                                                                                                                   |\n| Open Notes                    | openNotes                   | Opens the Notes view. Each item allows user notes to be added.                                                                                                                                                                                                            |\n| Open Sketchpad                | openSketchpad               | Opens the Sketchpad view. Each item allows a sketchpad.                                                                                                                                                                                                                   |\n| External                      | external:                   | Opens and external URL. This allows you to launch content from any URL on the web. You can also utilize URL's the mobile device supports.                                                                                                                                 |",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"yesNoNoLinkId": {
					"name": "No Link ID",
					"description": {
						"description": "Links to the item with the ID specified when you click No. If linking within this checklist then prepend the ID with a #. e.g. #preflight.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251"
							},
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},
				"yesNoNoLinkAction": {
					"name": "No Link Action",
					"description": {
						"description": "The action to perform when linking. The following are the supported link actions:\n\n| Name                          | Inline Command              | Description                                                                                                                                                                                                                                                               |\n|-------------------------------|-----------------------------|---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|\n| Goto                          | goto:                       | Goto an item with an ID.                                                                                                                                                                                                                                                  |\n| Goto Unchecked                | gotoUnchecked:              | Goto the first unchecked item with an ID.                                                                                                                                                                                                                                 |\n| Goto (New Session)            | newSessionAndGoto:          | This creates a new session for the checklist and then does a goto to the item.                                                                                                                                                                                            |\n| Goto (Reset Items In Range)   | resetRangeAndGoto:          | Goto an item and reset all the items in between the one you are currently on. The item you are jumping to should typically be before the item you are jumping from. An example of its usage would be to reset all the items from takeoff to landing after a touch-and-go. |\n| Goto (Check Items In Range)   | checkRangeAndGoto:          | Goto an item and check all the items in between the one you are currently on. The item you are jumping to should typically be after the item you are jumping from.                                                                                                        |\n| Goto and Return               | gotoAndReturn:              | Goto an item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                                            |\n| Goto Unchecked and Return     | gotoUncheckedAndReturn:     | Goto the first unchecked item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                           |\n| Goto and Return (New Session) | newSessionAndGotoAndReturn: | This creates a new session for the checklist and then does a goto to the item. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                      |\n| Goto and Open Birdseye View   | gotoAndOpenBirdseyeView:    | Goto an item with an ID and switch to Birdseye View.                                                                                                                                                                                                                      |\n| Reset Current Checklist       | resetCurrentChecklist       | Resets the current Checklist. This gives you a new session of the Checklist which effectively clears all items to their default state.                                                                                                                                    |\n| Reset Current List            | resetCurrentList            | Resets the current List. This clears all items to their default state in the current List.                                                                                                                                                                                |\n| Reset Current Section         | resetCurrentSection         | Resets the current Section. This clears all items to their default state in the current Section.                                                                                                                                                                          |\n| Open Comments                 | openComments                | Opens the Comments view. The Comments view allows detailed rich text content to be added for each item.                                                                                                                                                                   |\n| Open Notes                    | openNotes                   | Opens the Notes view. Each item allows user notes to be added.                                                                                                                                                                                                            |\n| Open Sketchpad                | openSketchpad               | Opens the Sketchpad view. Each item allows a sketchpad.                                                                                                                                                                                                                   |\n| External                      | external:                   | Opens and external URL. This allows you to launch content from any URL on the web. You can also utilize URL's the mobile device supports.                                                                                                                                 |",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"yesNoNaLinkId": {
					"name": "N/A Link ID",
					"description": {
						"description": "Links to the item with the ID specified when you click N/A. If linking within this checklist then prepend the ID with a #. e.g. #preflight.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251"
							},
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},
				"yesNoNaLinkAction": {
					"name": "N/A Link Action",
					"description": {
						"description": "The action to perform when linking. The following are the supported link actions:\n\n| Name                          | Inline Command              | Description                                                                                                                                                                                                                                                               |\n|-------------------------------|-----------------------------|---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|\n| Goto                          | goto:                       | Goto an item with an ID.                                                                                                                                                                                                                                                  |\n| Goto Unchecked                | gotoUnchecked:              | Goto the first unchecked item with an ID.                                                                                                                                                                                                                                 |\n| Goto (New Session)            | newSessionAndGoto:          | This creates a new session for the checklist and then does a goto to the item.                                                                                                                                                                                            |\n| Goto (Reset Items In Range)   | resetRangeAndGoto:          | Goto an item and reset all the items in between the one you are currently on. The item you are jumping to should typically be before the item you are jumping from. An example of its usage would be to reset all the items from takeoff to landing after a touch-and-go. |\n| Goto (Check Items In Range)   | checkRangeAndGoto:          | Goto an item and check all the items in between the one you are currently on. The item you are jumping to should typically be after the item you are jumping from.                                                                                                        |\n| Goto and Return               | gotoAndReturn:              | Goto an item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                                            |\n| Goto Unchecked and Return     | gotoUncheckedAndReturn:     | Goto the first unchecked item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                           |\n| Goto and Return (New Session) | newSessionAndGotoAndReturn: | This creates a new session for the checklist and then does a goto to the item. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                      |\n| Goto and Open Birdseye View   | gotoAndOpenBirdseyeView:    | Goto an item with an ID and switch to Birdseye View.                                                                                                                                                                                                                      |\n| Reset Current Checklist       | resetCurrentChecklist       | Resets the current Checklist. This gives you a new session of the Checklist which effectively clears all items to their default state.                                                                                                                                    |\n| Reset Current List            | resetCurrentList            | Resets the current List. This clears all items to their default state in the current List.                                                                                                                                                                                |\n| Reset Current Section         | resetCurrentSection         | Resets the current Section. This clears all items to their default state in the current Section.                                                                                                                                                                          |\n| Open Comments                 | openComments                | Opens the Comments view. The Comments view allows detailed rich text content to be added for each item.                                                                                                                                                                   |\n| Open Notes                    | openNotes                   | Opens the Notes view. Each item allows user notes to be added.                                                                                                                                                                                                            |\n| Open Sketchpad                | openSketchpad               | Opens the Sketchpad view. Each item allows a sketchpad.                                                                                                                                                                                                                   |\n| External                      | external:                   | Opens and external URL. This allows you to launch content from any URL on the web. You can also utilize URL's the mobile device supports.                                                                                                                                 |",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"yesNoShowNa": {
					"name": "Show N/A",
					"description": "Determines if it should show the N/A option."
				},
				"yesNoAdvanceOnSelect": {
					"name": "Advance on Select",
					"description": "When this is enabled it will advance as soon as the selection is made."
				},

				// Picker
				"pickerViewType": {
					"name": "View Type",
					"description": "A **Picker** allows you to createt a menu of options to choose from. The **View Type* allows you to choose a layout. There are two options, Picker or Buttons. Picker is the standard Picker control on your operating system. Buttons presents the Picker items as a set of buttons. When you have a small amount of items this is a good choice because you don't have to scroll through the items to make a selection."
				},
				"pickerLabel": {
					"name": "Label",
					"description": "The **Label** is the content the user sees for the option."
				},
				"pickerValue": {
					"name": "Value",
					"description": "The **Value** is a coded ID that is stored when a selection is made. When Link On Select is used, this value should be the Link ID. For example, if the Link Action is Goto, then you would out a value of *#postflight* if you wantt tto jump to an item with an ID *postflight*. This value can also bbe used in scripting to perform actions based on the value."
				},
				"pickerProperties": {
					"name": "Properties (optional)",
					"description": "This is an advanced option that allows you to add a JSON object for specific bahvior when this option is selected."
				},
				"pickerPlaceholder": {
					"name": "Placeholder",
					"description": "Allows you to provide a placeholder or hint text in the field to guide the user."
				},
				"pickerDefaultValue": {
					"name": "Default Value",
					"description": "Allows you to set a default value for the picker."
				},
				"pickerAdvanceOnSelect": {
					"name": "Advance On Select",
					"description": "When this is enabled it will advance as soon as the selection is made."
				},
				"pickerAddPickerItems": {
					"name": "Add Picker Items",
					"description": "A Picker item consists of a Label and a Value and optional Properties. The Label is the content the user sees. The Value a behind-the-scenes value that gets stored with the selection. This value can be used by Visible If... to hide/show content based on selection of the value. The value can also be used to link to a different part of the activity based on the selection made. Under Linking Options you would select Link on Select to use this feature. For this, you would prepend the values with a # to jump internally in the activity. e.g. #resources. You would also add an ID *resources* to the List, Secttion or Item you want to jump to."
				},
				"pickerDataSource": {
					"name": "Data Source",
					"description": "Upload a JSON file of Picker Items data."
				},

				"pickerLinkOnSelect": {
					"name": "Link On Select",
					"description": {
						"description": "Linking allows you you to navigate to another part of the checklist or to another checklist. Turning this property on will perform the link action. You would entter the Link ID in the Value field for the option. When linking within the checklist, you add a # sign before the ID. e.g. #postflight. For linking to work, you must also set an ID on the item you are linking to. See the ID property for details on setting an ID on items in the checklist.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"pickerLinkAction": {
					"name": "Link Action",
					"description": {
						"description": "The action to perform when linking. The following are the supported link actions:   \n\n| Name                          | Inline Command              | Description                                                                                                                                                                                                                                                               |\n|-------------------------------|-----------------------------|---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|\n| Goto                          | goto:                       | Goto an item with an ID.                                                                                                                                                                                                                                                  |\n| Goto Unchecked                | gotoUnchecked:              | Goto the first unchecked item with an ID.                                                                                                                                                                                                                                 |\n| Goto (New Session)            | newSessionAndGoto:          | This creates a new session for the checklist and then does a goto to the item.                                                                                                                                                                                            |\n| Goto (Reset Items In Range)   | resetRangeAndGoto:          | Goto an item and reset all the items in between the one you are currently on. The item you are jumping to should typically be before the item you are jumping from. An example of its usage would be to reset all the items from takeoff to landing after a touch-and-go. |\n| Goto (Check Items In Range)   | checkRangeAndGoto:          | Goto an item and check all the items in between the one you are currently on. The item you are jumping to should typically be after the item you are jumping from.                                                                                                        |\n| Goto and Return               | gotoAndReturn:              | Goto an item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                                            |\n| Goto Unchecked and Return     | gotoUncheckedAndReturn:     | Goto the first unchecked item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                           |\n| Goto and Return (New Session) | newSessionAndGotoAndReturn: | This creates a new session for the checklist and then does a goto to the item. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                      |\n| Goto and Open Birdseye View   | gotoAndOpenBirdseyeView:    | Goto an item with an ID and switch to Birdseye View.                                                                                                                                                                                                                      |\n| Reset Current Checklist       | resetCurrentChecklist       | Resets the current Checklist. This gives you a new session of the Checklist which effectively clears all items to their default state.                                                                                                                                    |\n| Reset Current List            | resetCurrentList            | Resets the current List. This clears all items to their default state in the current List.                                                                                                                                                                                |\n| Reset Current Section         | resetCurrentSection         | Resets the current Section. This clears all items to their default state in the current Section.                                                                                                                                                                          |\n| Open Comments                 | openComments                | Opens the Comments view. The Comments view allows detailed rich text content to be added for each item.                                                                                                                                                                   |\n| Open Notes                    | openNotes                   | Opens the Notes view. Each item allows user notes to be added.                                                                                                                                                                                                            |\n| Open Sketchpad                | openSketchpad               | Opens the Sketchpad view. Each item allows a sketchpad.                                                                                                                                                                                                                   |\n| External                      | external:                   | Opens and external URL. This allows you to launch content from any URL on the web. You can also utilize URL's the mobile device supports.                                                                                                                                 |",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				// Choice
				"choiceAdvanceOnSelect": {
					"name": "Advance On Select",
					"description": "When this is enabled it will advance as soon as the selection is made."
				},
				"choiceLinkOnSelect": {
					"name": "Link On Select",
					"description": {
						"description": "Linking allows you you to navigate to another part of the checklist or to another checklist. Turning this property on will perform the link action. You would entter the Link ID in the Value field for the option. When linking within the checklist, you add a # sign before the ID. e.g. #postflight. For linking to work, you must also set an ID on the item you are linking to. See the ID property for details on setting an ID on items in the checklist.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"choiceLinkAction": {
					"name": "Link Action",
					"description": {
						"description": "The action to perform when linking. The following are the supported link actions:   \n\n| Name                          | Inline Command              | Description                                                                                                                                                                                                                                                               |\n|-------------------------------|-----------------------------|---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|\n| Goto                          | goto:                       | Goto an item with an ID.                                                                                                                                                                                                                                                  |\n| Goto Unchecked                | gotoUnchecked:              | Goto the first unchecked item with an ID.                                                                                                                                                                                                                                 |\n| Goto (New Session)            | newSessionAndGoto:          | This creates a new session for the checklist and then does a goto to the item.                                                                                                                                                                                            |\n| Goto (Reset Items In Range)   | resetRangeAndGoto:          | Goto an item and reset all the items in between the one you are currently on. The item you are jumping to should typically be before the item you are jumping from. An example of its usage would be to reset all the items from takeoff to landing after a touch-and-go. |\n| Goto (Check Items In Range)   | checkRangeAndGoto:          | Goto an item and check all the items in between the one you are currently on. The item you are jumping to should typically be after the item you are jumping from.                                                                                                        |\n| Goto and Return               | gotoAndReturn:              | Goto an item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                                            |\n| Goto Unchecked and Return     | gotoUncheckedAndReturn:     | Goto the first unchecked item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                           |\n| Goto and Return (New Session) | newSessionAndGotoAndReturn: | This creates a new session for the checklist and then does a goto to the item. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                      |\n| Goto and Open Birdseye View   | gotoAndOpenBirdseyeView:    | Goto an item with an ID and switch to Birdseye View.                                                                                                                                                                                                                      |\n| Reset Current Checklist       | resetCurrentChecklist       | Resets the current Checklist. This gives you a new session of the Checklist which effectively clears all items to their default state.                                                                                                                                    |\n| Reset Current List            | resetCurrentList            | Resets the current List. This clears all items to their default state in the current List.                                                                                                                                                                                |\n| Reset Current Section         | resetCurrentSection         | Resets the current Section. This clears all items to their default state in the current Section.                                                                                                                                                                          |\n| Open Comments                 | openComments                | Opens the Comments view. The Comments view allows detailed rich text content to be added for each item.                                                                                                                                                                   |\n| Open Notes                    | openNotes                   | Opens the Notes view. Each item allows user notes to be added.                                                                                                                                                                                                            |\n| Open Sketchpad                | openSketchpad               | Opens the Sketchpad view. Each item allows a sketchpad.                                                                                                                                                                                                                   |\n| External                      | external:                   | Opens and external URL. This allows you to launch content from any URL on the web. You can also utilize URL's the mobile device supports.                                                                                                                                 |",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				"choiceLayout": {
					"name": "Choice Layout",
					"description": "Controls how single-choice and multi-choice options are arranged. Use Stack for a vertical list or Wrap for a compact visual grid."
				},
				"choiceSize": {
					"name": "Option Size [px]",
					"description": "Sets the default option control or image size in pixels for the choice item. Per-option style overrides can still change individual options."
				},
				"choiceHideBorder": {
					"name": "Hide Image Border",
					"description": "Removes the built-in border around image-based choice controls. This affects the image/control box itself, not the outer option card or row shell."
				},
				"choiceHideOptionBorder": {
					"name": "Hide Option Border",
					"description": "Removes the outer border and shell treatment around each choice option while keeping the option content and image/control visible."
				},
				"choiceGap": {
					"name": "Option Gap [px]",
					"description": "Controls the spacing between choice options. This works for both stacked and wrap layouts."
				},


				// Date Time
				"dateTimeType": {
					"name": "Type",
					"description": "Allows you to choose between Local Time or UTC Timer."
				},
				"dateTimeInitialDate": {
					"name": "Initial Date",
					"description": "Allows you to set the initial date and/or time. Supports literal values (date: 2026-03-13, time: 14:30, date-time: 2026-03-13 14:30), the keyword today, and ${...} templates."
				},
				"dateTimeMinuteInterval": {
					"name": "Minute Interval",
					"description": "Allows you to select the minute interval to present when selecting a time."
				},
				"dateTimeAdvanceOnSelect": {
					"name": "Advance on Select",
					"description": "When this is enabled it will advance as soon as the selection is made."
				},
				"dateTimePickerInline": {
					"name": "Show Picker Inline in Web Player",
					"description": "When this is enabled, the web player shows the calendar or time picker inline while the item is selected. When disabled, the picker opens only after the user clicks the date/time field."
				},

				// Barcode
				"barcodeTypes": {
					"name": "Barcode Type",
					"description": "There are many different barcode types supported. Leave this blank to auto-detect supported barcode types, or choose one or more types to restrict scanning."
				},
				"barcodeType": {
					"name": "Barcode Type",
					"description": "There are many different barcode types supported. Leave this blank to auto-detect supported barcode types, or choose one or more types to restrict scanning."
				},
				"barcodeManualEntryMultiline": {
					"name": "Manual Entry Multiline",
					"description": "Allows manually typed barcode values to include line breaks. Leave this off for normal barcode entry so pasted or typed values stay single-line."
				},
				"barcodeAllowEditScannedValue": {
					"name": "Allow Editing Scanned Value",
					"description": "When disabled, values captured by the camera are shown read-only and users can scan again or clear them. Enable this only when users should be able to correct or edit scanned data."
				},
				"barcodeNormalizeTrim": {
					"name": "Trim Whitespace",
					"description": "Removes whitespace from the beginning and end of scanned and manually entered barcode values before storing and validating them."
				},
				"barcodeNormalizeStripLineBreaks": {
					"name": "Strip Line Breaks",
					"description": "Removes line breaks from scanned and manually entered barcode values. Keep this enabled for normal barcodes; disable it only when QR codes intentionally contain multiple lines."
				},
				"barcodeNormalizeCase": {
					"name": "Normalize Case",
					"description": "Optionally converts scanned and manually entered barcode values to uppercase or lowercase before storing and validating them."
				},
				"barcodeNormalizeUpcAFromEan13": {
					"name": "Normalize UPC-A from EAN-13",
					"description": "When enabled, a 13-digit EAN-13 value that starts with 0 is stored as its 12-digit UPC-A value. This helps iOS scans match the number printed under UPC-A barcodes."
				},
				"barcodeExpectedValue": {
					"name": "Expected Value",
					"description": "Optional value to compare against the scanned barcode after normalization. Use this when a specific SKU, asset tag, order number, or encoded prefix should be accepted."
				},
				"barcodeExpectedMatchMode": {
					"name": "Expected Match Mode",
					"description": "Controls how Expected Value is compared to the scanned barcode. Regex treats Expected Value as a JavaScript regular expression."
				},
				"barcodeValidationPattern": {
					"name": "Validation Pattern",
					"description": "Optional JavaScript regular expression that the normalized barcode value must match. Example: ^[0-9]{12}$ for a 12-digit UPC-A value."
				},
				"barcodeValidationMessage": {
					"name": "Validation Message",
					"description": "Message shown in the mobile player when a scanned or manually entered barcode does not satisfy the expected value or validation pattern."
				},

				// Media
				"mediaType": {
					"name": "Media Type",
					"description": "Allows you to select the media type. Both Photo and Video, or Photo Only or Video Only. On Android, you can only use Photo Only or Video Only."
				},
				"mediaAddMediaButtonTitle": {
					"name": "Add Media Button Title",
					"description": "Allows you to change the title of the button to add media."
				},
				"mediaUploadTitle": {
					"name": "Upload Title",
					"description": "Allows you to change the title of the upload menu."
				},
				"mediaCaptureMediaButtonTitle": {
					"name": "Capture Media Button Title",
					"description": "Allows you to change the title of the capture media button."
				},

				// Sketch Pad
				"sketchPadHeight": {
					"name": "Height",
					"description": "The height of the Sketchpad."
				},
				"sketchPadBackgroundColor": {
					"name": "Background Color",
					"description": "The background color of the Sketchpad."
				},
				"sketchPadPenColor": {
					"name": "Pen Color",
					"description": "Allows you to choose a pen color for the Sketchpad."
				},
				"sketchPadPenWidth": {
					"name": "Pen Width",
					"description": "Allows you to choose a pen width for the Sketchpad."
				},


				"label1FontColor": {
					"name": "Label 1 Font Color",
					"description": "Select a font color for Label 1."
				},
				"label2FontColor": {
					"name": "Label 2 Font Color",
					"description": "Select a font color for Label 2."
				},
				"backgroundColor": {
					"name": "Background Color",
					"description": "Select a background color for the Item card."
				},

				"stylesCss": {
					"name": "Styles",
					"description": {
						"description": "Add CSS in the form of a JSON object to set style information on specific items in the outline you are creating for an activity. For example, you can set the font information for all items or change the background color of each section header. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "Stylesheet Properties",
								"url": "https://ambifi.atlassian.net/wiki/spaces/DOC/pages/941719561/Stylesheet+JSON"
							},
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},
				"classes": {
					"name": "Classes",
					"description": {
						"description": "Reference classes you create in a stylesheet. For example you can create a class .warning-box and then reference it from any item. This is an advanced capability and requires an understanding of web technologies like CSS to get the most out of it.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Styling",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/styling/index.html"
							}
						]
					}
				},

				// Print Properties
				"keepTogether": {
					"name": "Keep Together",
					"description": "Keep Together attempts to keep the Item on the same page."

				},
				"breakBefore": {
					"name": "Break Before",
					"description": "Breaks the page before this Item."
				},
				"breakBeforeHeight": {
					"name": "Break Before Height",
					"description": "Creates an area with the height specified before the break."
				},
				"breakAfter": {
					"name": "Break After",
					"description": "Breaks the page after the Item."
				},
				"breakAfterHeight": {
					"name": "Break After Height",
					"description": "Creates an area with the height after the break."

				},
				"customProperties": {
					"name": "Custom Properties (JSON Format)",
					"description": "You can supply custom properties in JSON format that get merged in with the content model. This allows you to extend the base content model for this Item."
				},

				"relatedItems": {
					"name": "Related Items",
					"description": "Associate any number of related items with a List, Section or Item. If you associated them with a List or Section then the related item will appear for every item in those containers. Related items will appear in a side panel on the right. This allows an author to add some links whenever a user navigates through an activity and provides some extra context and knowledge."
				},

				// Advanced
				"filterTags": {
					"name": "Filter Tags",
					"description": "**Filter Tags** is a feature that allows you to filter your activity when it is launched. Enter tags such as Beginner, or Advanced. When you tag something you are saying you want the option to hide or show the Item when the activity runs. Items that are not tagged will always show, and many of your Items would not be tagged. But if you have a specific Item you want to display like content to show if you are a beginner, then tag that Beginner."

				},
				"groupNames": {
					"name": "Group Names",
					"description": {
						"description": "**Group Names** allow you to group a number of Items. This can be used with scripting to apply operations on a number of items.",
						"learnMoreLinks": [
							{
								"title": "AmniFi Orientation: Basics of Grouping Items",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/item-groups/index.html"
							}
						]
					}
				},

				"suppressPrint": {
					"name": "Don't Print",
					"description": "Excludes the Item when the checklist is printed."
				},
				"startTrackingWhenChecked": {
					"name": "Start Tracking when Checked",
					"description": "When this item is checked, it starts geolocation tracking. This allows you to set what item in the checklist you would want geolocattion tracking to start. For example, Ignition - On"
				},
				"stopTrackingWhenChecked": {
					"name": "Stop Tracking when Checked",
					"description": "When this ite is checked, it stops the gelocation tracking. This allows you to set what item in the checklist you would want geolocation tracking to stop. For example, Mixture - Full Lean"
				},
				"startTimerWhenChecked": {
					"name": "Start Logbook Elapsed Timer when Checked",
					"description": "When this item is checked, it starts the Logbook timer. This allows you to set what item in the checklist you would want the Logbook timer to start. For example, Ignition - On."
				},
				"stopTimerWhenChecked": {
					"name": "Stop Logbook Elapsed Timer when Checked",
					"description": "When this item is checked, it starts the Logbook timer. This allows you to set what item in the checklist you would want the Logbook timer to start. For example, Ignition - On."
				},
				"saveOnComplete": {
					"name": "Save On Complete (Check)",
					"description": "When this item is checked it will save the data of the activity."
				},
				"saveAndExitOnComplete": {
					"name": "Save and Exit On Complete (Check)",
					"description": "When this item is checked it will save and exit the activity."
				},
				"generateReportOnComplete": {
					"name": "Generate Report On Complete (Check)",
					"description": "When this item is checked it will print a report."
				},
				"reportTemplate": {
					"name": "Report Template ID",
					"description": "The ID of the report to generate."
				},
				"startNamedTimers": {
					"name": "Start Named Timers",
					"description": {
						"description": "When this item is checked, it starts any named timers. You can create named timers in AmbiFi Cloud that can be used in your checklist. An example of a named timer would be to remind you to check the fuel selector every 45 minutes, or to remind you to check common overlooked items such as closing the cowl flaps when in cruise.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Timers",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/timers/index.html"
							}
						]
					}
				},
				"stopNamedTimers": {
					"name": "Stop Named Timers",
					"description": {
						"description": "When this item is checked, it stops any named timers. You can create named timers in AmbiFi Cloud that can be used in your checklist. An example of a named timer would be to remind you to check the fuel selector every 45 minutes, or to remind you to check common overlooked items such as closing the cowl flaps when in cruise.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Timers",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/timers/index.html"
							}
						]
					}
				},

				"navigationTitle": {
					"name": "Navigation Title",
					"description": "A shorter title for this item that will be sown in navigation."
				},
				"dontShowInNavigationTreeView": {
					"name": "Don't Show in Navigation Tree View",
					"description": "In the Breadcrumb View, there is a navigation tree view of the entire activity. This hides the Item from that view."
				},

				"authorProperties": {
					"name": "Author Properties",
					"description": "These are advanced properties that can be set at different levels in the authoring hierarchy."
				},
				"itemHeight": {
					"name": "Item Height [%]",
					"description": "Choose a height for the item. This only applies when the item is not full screen. A value of Default means the height of the item will automatically grow to fit the content."
				},
				"fullscreenChoiceOverlay": {
					"name": "Overlay Choices In Fullscreen",
					"description": "For picker and choice items in web fullscreen screens, places the choice controls in an overlay layer so they can sit on top of background images or other content instead of flowing below the content."
				},
				"fullscreenChoicePlacement": {
					"name": "Fullscreen Choice Overlay Placement",
					"description": "When fullscreen choice overlay is enabled, anchors the choice controls to the top, center, or bottom of the fullscreen item."
				},
				"fullscreenChoiceTitle": {
					"name": "Fullscreen Choice Title",
					"description": "Change the title shown above the fullscreen choice panel. Leave blank to hide the title and separator completely."
				},
				"fullscreenChoicePanelOpaque": {
					"name": "Opaque Fullscreen Choice Panel",
					"description": "Uses a solid white fullscreen choice panel instead of the translucent panel style. This is useful when background images make the overlay harder to read."
				},
				"itemButtonOkLabel": {
					"name": "Button Label",
					"description": "Change the label of the OK buttton. The OK button is displayed on a Check Item if you select the Label Only option for the Check Item. It also appears on other item types to move on after accepting a value. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemButtonBackLabel": {
					"name": "Back Button Label",
					"description": "Change the label of the Back button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use when Back Button Visibility resolves to Visible and a previous visible item exists."
				},
				"itemButtonNotApplicableLabel": {
					"name": "N/A Button Label",
					"description": "Change the label of the N/A button. This is an inherited property. You can define it at any level in the outline so child items use the same label when N/A Button Visibility resolves to Visible."
				},
				"itemButtonOkVisibility": {
					"name": "Visibility",
					"description": "Change the visibility of the OK button. This is an inherited property. You can define at any level in the outline (Activity, List, Section) this visibility."
				},
				"itemButtonBackVisibility": {
					"name": "Back Button Visibility",
					"description": "Controls whether the Back button can appear for item OK footers. This is an inherited property. When set to Visible, the player will show Back when a previous visible item exists."
				},
				"itemButtonNotApplicableVisibility": {
					"name": "N/A Button Visibility",
					"description": "Controls whether the N/A button can appear in the item footer. This is an inherited property. When set to Visible, the player lets the user mark the current item as not applicable without entering a value."
				},
				"itemButtonOkPendingBehavior": {
					"name": "Pending Behavior",
					"description": "Controls how the OK button behaves before an item is ready to submit. Choose between keeping it visible but disabled, or hiding it until the item is ready."
				},
				"fullscreenActionVariant": {
					"name": "Fullscreen Variant",
					"description": "In fullscreen modes, choose whether items use the classic footer bar or the modern floating action variant. This is an inherited property."
				},
				"fullscreenActionPlacement": {
					"name": "Fullscreen Placement",
					"description": "When a fullscreen action variant is active, choose whether the fullscreen actions stay pinned as an overlay or stay pinned below the content area. This is an inherited property."
				},
				"fullscreenActionFlowWhenScrollable": {
					"name": "Flow With Content When Scrollable",
					"description": "When enabled, fullscreen actions use the selected pinned placement while the content fits on screen, but move to the end of the content once the content needs to scroll. This is an inherited property."
				},
				"fullscreenSwipeNavigation": {
					"name": "Fullscreen Swipe Navigation",
					"description": "Controls whether fullscreen label-only screens can use swipe up and swipe down for navigation when the screen is not scrollable and does not have blocking animation behavior. This is an inherited property."
				},
				"fullscreenSwipeSound": {
					"name": "Fullscreen Swipe Sound",
					"description": "Controls whether fullscreen swipe navigation plays the whoosh sound effect when a swipe navigation gesture succeeds. Auto disables the sound in Vertical Fullscreen View (TikTok Style) and enables it in other fullscreen vertical views. This is an inherited property."
				},
				"fullscreenLabelHideControl": {
					"name": "Fullscreen Text Hide Control",
					"description": "Controls whether users can hide label text on fullscreen label-only screens with background image or video. Auto allows hiding only when the item text is bottom-aligned with justifyContent: flex-end in Vertical View / Fullscreen, Vertical Fullscreen View (TikTok Style), or Fullscreen View (Game Style). This is an inherited property."
				},
				"fullscreenActionNavAlignment": {
					"name": "Fullscreen Nav Alignment",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary navigation cluster stays left-aligned or centered within the available footer lane while utility controls remain on the right. This is an inherited property."
				},
				"fullscreenActionNavOrder": {
					"name": "Fullscreen Nav Order",
					"description": "When fullscreen navigation shows both the primary action and Back, choose whether the primary action appears first or Back appears first. This is an inherited property."
				},
				"fullscreenActionStyle": {
					"name": "Fullscreen Floating Style",
					"description": "When Floating Fullscreen Actions are active, choose whether the primary action is emphasized with a filled color or kept minimal on the shared surface. This is an inherited property."
				},
				"fullscreenActionPrimaryColor": {
					"name": "Floating Primary Color",
					"description": "Set the fill color used by the emphasized primary fullscreen floating action, such as Next. This is an inherited property."
				},
				"fullscreenActionSurfaceColor": {
					"name": "Floating Surface Color",
					"description": "Set the shared surface color used by fullscreen floating action capsules such as the primary navigation cluster and More button. This is an inherited property."
				},
				"fullscreenActionToolBackgroundColor": {
					"name": "Tool Background Color",
					"description": "Set the background color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to reuse the floating surface color. This is an inherited property."
				},
				"fullscreenActionToolForegroundColor": {
					"name": "Tool Foreground Color",
					"description": "Set the text and icon color used by fullscreen tool buttons such as More, Related, and Attachments. Leave blank to auto-contrast against the tool background color. This is an inherited property."
				},
				"itemCommentsLabel": {
					"name": "More Button Label",
					"description": "Change the label of the Comments buttton. The Comments button is displayed on an Item if there are comments added from the author and the Comments Visibility is set to TRUE. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemCommentsIcon": {
					"name": "More Button Icon",
					"description": "Use a Font Awesome icon name for the More button. This is an inherited property."
				},
				"itemCommentsBackgroundColor": {
					"name": "More Button Background Color",
					"description": "Set the background color used by the More button. Leave blank to use the smart default blue fill derived from the fullscreen primary color. This is an inherited property."
				},
				"itemCommentsForegroundColor": {
					"name": "More Button Foreground Color",
					"description": "Set the text and icon color used by the More button. Leave blank to auto-contrast against the More button background color. This is an inherited property."
				},
				"itemRelatedItemsLabel": {
					"name": "Related Button Label",
					"description": "Change the label of the Related Items buttton. The Related Items button is displayed on an Item if you associated Related Items. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemRelatedItemsIcon": {
					"name": "Related Button Icon",
					"description": "Use a Font Awesome icon name for the Related button. This is an inherited property."
				},
				"itemRelatedItemsBackgroundColor": {
					"name": "Related Button Background Color",
					"description": "Set the background color used by the Related button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemRelatedItemsForegroundColor": {
					"name": "Related Button Foreground Color",
					"description": "Set the text and icon color used by the Related button. Leave blank to auto-contrast against the Related button background color. This is an inherited property."
				},
				"itemAttachmentsLabel": {
					"name": "Attachments Button Label",
					"description": "Change the label of the Attachments button. Leave blank to show no label by default. This is an inherited property. You can define at any level in the outline (Activity, List, Section) a label that all the children in the container will use."
				},
				"itemAttachmentsIcon": {
					"name": "Attachments Button Icon",
					"description": "Use a Font Awesome icon name for the Attachments button. This is an inherited property."
				},
				"itemAttachmentsBackgroundColor": {
					"name": "Attachments Button Background Color",
					"description": "Set the background color used by the Attachments button. Leave blank to use the default tool surface color. This is an inherited property."
				},
				"itemAttachmentsForegroundColor": {
					"name": "Attachments Button Foreground Color",
					"description": "Set the text and icon color used by the Attachments button. Leave blank to auto-contrast against the Attachments button background color. This is an inherited property."
				},

				"linkOnCheck": {
					"name": "Link On Check",
					"description": {
						"description": "Linking allows you you to navigate to another part of the checklist or to another checklist. Turning this property on will perform the link action. The Link ID is where you specifiy the ID of the item you want to link to. When linking within the checklist, you add a # sign before the ID. e.g. #postflight. For linking to work, you must also set an ID on the item you are linking to. See the ID property for details on setting an ID on items in the checklist.",
						"learnMoreLinks": [
							{
								"title": "AmbiFi Orientation: Basics of Linking",
								"url": "https://publications.ambifi.com/ambifi/learning/orientation/linking/index.html"
							},
							{
								"title": "Linking Command Reference",
								"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
							},
							{
								"title": "Linking in the Form Items",
								"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
							},
							{
								"title": "How do I use linking in checklist?",
								"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
							},
							{
								"title": "Advanced Linking in a Picker Item using Buttons",
								"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
							}
						]
					}
				},
				// "linkId": {
				// 	"name": "Link ID",
				// 	"description": "Links to the item with the ID specified when you check the item. If linking within this checklist then prepend the ID with a #. e.g. #preflight."
				// },
				// "linkAction": {
				// 	"name": "Link Action",
				// 	"description": {
				// 		"description": "The action to perform when linking. The following are the supported link actions:\n\n| Name                          | Inline Command              | Description                                                                                                                                                                                                                                                               |\n|-------------------------------|-----------------------------|---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------|\n| Goto                          | goto:                       | Goto an item with an ID.                                                                                                                                                                                                                                                  |\n| Goto Unchecked                | gotoUnchecked:              | Goto the first unchecked item with an ID.                                                                                                                                                                                                                                 |\n| Goto (New Session)            | newSessionAndGoto:          | This creates a new session for the checklist and then does a goto to the item.                                                                                                                                                                                            |\n| Goto (Reset Items In Range)   | resetRangeAndGoto:          | Goto an item and reset all the items in between the one you are currently on. The item you are jumping to should typically be before the item you are jumping from. An example of its usage would be to reset all the items from takeoff to landing after a touch-and-go. |\n| Goto (Check Items In Range)   | checkRangeAndGoto:          | Goto an item and check all the items in between the one you are currently on. The item you are jumping to should typically be after the item you are jumping from.                                                                                                        |\n| Goto and Return               | gotoAndReturn:              | Goto an item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                                            |\n| Goto Unchecked and Return     | gotoUncheckedAndReturn:     | Goto the first unchecked item with an ID. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                                                           |\n| Goto and Return (New Session) | newSessionAndGotoAndReturn: | This creates a new session for the checklist and then does a goto to the item. This also presents a Go Back button after navigation so that you can return to where you jumped from.                                                                                      |\n| Goto and Open Birdseye View   | gotoAndOpenBirdseyeView:    | Goto an item with an ID and switch to Birdseye View.                                                                                                                                                                                                                      |\n| Reset Current Checklist       | resetCurrentChecklist       | Resets the current Checklist. This gives you a new session of the Checklist which effectively clears all items to their default state.                                                                                                                                    |\n| Reset Current List            | resetCurrentList            | Resets the current List. This clears all items to their default state in the current List.                                                                                                                                                                                |\n| Reset Current Section         | resetCurrentSection         | Resets the current Section. This clears all items to their default state in the current Section.                                                                                                                                                                          |\n| Open Comments                 | openComments                | Opens the Comments view. The Comments view allows detailed rich text content to be added for each item.                                                                                                                                                                   |\n| Open Notes                    | openNotes                   | Opens the Notes view. Each item allows user notes to be added.                                                                                                                                                                                                            |\n| Open Sketchpad                | openSketchpad               | Opens the Sketchpad view. Each item allows a sketchpad.                                                                                                                                                                                                                   |\n| External                      | external:                   | Opens and external URL. This allows you to launch content from any URL on the web. You can also utilize URL's the mobile device supports.                                                                                                                                 |",
				// 		"learnMoreLinks": [
				// 			{
				// 				"title": "Linking Command Reference",
				// 				"url": "https://forum.miralouaero.com/t/linking-command-reference/520?u=admin"
				// 			},
				// 			{
				// 				"title": "Linking in the Form Items",
				// 				"url": "https://forum.miralouaero.com/t/linking-in-the-form-items/251?u=admin"
				// 			},
				// 			{
				// 				"title": "How do I use linking in checklist?",
				// 				"url": "https://forum.miralouaero.com/t/how-do-i-use-linking-in-checklist/172/2?u=admin"
				// 			},
				// 			{
				// 				"title": "Advanced Linking in a Picker Item using Buttons",
				// 				"url": "https://forum.miralouaero.com/t/advanced-linking-in-a-picker-item-using-buttons/519?u=admin"
				// 			}
				// 		]
				// 	}
				// },

				"valueTrigger": {
					"name": "Value Trigger Editor",
					"description": {
						"description": "The **Value Trigger Editor** allows you to run custom scripts based on interacting with this item. For example, when you present a Yes / No question you may want to perform custom actions based on answering yes or no.",
						"learnMoreLinks": [
							{
								"title": "Value Triggers Information",
								"url": "https://forum.miralouaero.com/t/value-triggers-information/753?u=admin"
							},
							{
								"title": "Runtime API Reference",
								"url": "https://checklist.miracheck.com/runtimeApi/RuntimeApi.html"
							}
						]
					}
				},

			}
		}
	},
	"timer": {
		"types": {
			"countdown": "Count Down",
			"countup": "Count Up",
			"custom": "Custom"
		},
		"modes": {
			"normal": "Normal (Floating)",
			"modal": "Modal",
			"appBar": "App Bar"
		},
		"viewTypes": {
			"top-left": "Top Left",
			"top-right": "Top Right"
		}

	},
	"visibleIf": {
		"ignoreEmptyValues": {
			"name": "Ignore Empty Values",
			"description": "If there is no value set then it initially will not be visible."
		}
	},
	"loadingStatuses": {
		"loadingDrive": "Loading drive ... please be patient."
	}
};

export default content;
